// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:04.852Z
// Property: Millcreek Woods Apartment Homes (ID: 6767906449167603)
// Collections: 21 amenities, 6 floorplans (live), 65 photos, 77 POIs, 4 reviews, 5 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167603",
  "property_external_id": "1124173",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/millcreek-woods-apartment-homes-olathe-ks/8fzzz72/",
  "property_google_business_url": "https://www.google.com/maps/place/Millcreek+Woods+Apartment+Homes/@38.9099888,-94.799606,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c095e9ad7222ab:0x20e3b4b56a0928d9!8m2!3d38.9099888!4d-94.799606!16s%2Fg%2F113f8j_c1?entry=ttu&g_ep=EgoyMDI2MDkxNS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124173 p1099125",
  "property_status": null,
  "property_slug": "millcreek-woods-apartment-homes",
  "property_name": "Millcreek Woods Apartment Homes",
  "property_website_url": "https://www.millcreekwoodsapts.com/",
  "property_domain": "https://www.millcreekwoodsapts.com/",
  "property_address": "1711 N Ridgeview Rd",
  "property_full_address": "1711 N Ridgeview Rd, Olathe, KS 66061",
  "property_address_1": "1711 N Ridgeview Rd",
  "property_address_2": null,
  "property_address_city": "Olathe",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66061",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Millcreek Apartments",
  "property_address_latitude": "38.9099888",
  "property_address_longitude": "-94.7996539",
  "property_email": "rentcafe.mc@pricekc.com",
  "property_phone": "(913) 586-1674",
  "property_call_tracking_phone": "913-586-1674",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Green space meets connected Olathe convenience</strong> at Millcreek Woods Apartment Homes, where studio, one-, and two-bedroom layouts sit beside a scenic lake and one-mile nature trail. Explore available floor plans, preview amenities, or schedule a tour to see it all in person.</p>",
  "property_long_description": "<p><strong>Green space, recreation, and connected Olathe convenience come together at Millcreek Woods Apartment Homes.</strong> Choose from studio, one-bedroom, and two-bedroom layouts with everyday comforts like spacious closets, dishwashers, high-speed internet readiness, air conditioning, and select fireplaces, patios or balconies, stainless steel appliances, upgraded lighting, and espresso or white cabinetry. Beyond your door, the community stands out with a scenic lake, one-mile nature trail, swimming pool and sundeck, clubhouse lounge, fitness center, and courts for basketball, tennis, and volleyball. Compare available <a href=\"/floor-plans\">floor plans</a> or preview the full <a href=\"/amenities\">amenity collection</a>.</p><p>In the Millcreek neighborhood near Ridgeview Road and 119th Street, you’re minutes from Northside Plaza, Ridgeview Falls, Olathe Station shopping and dining, Main Event, AMC, and Downtown Olathe. Mahaffie Stagecoach Stop &amp; Farm, Ernie Miller Nature Center, Garmin, Johnson County Community College, and Olathe Medical Center are also within easy reach, giving you a green, lake-adjacent setting without losing quick access to the places that shape daily life in Olathe.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-dea2-73eb-bc37-f344fce8469b.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with fireplace, sofa, chairs, coffee table, and kitchen with bar seating.",
    "public_id": "01a0102a-dea2-73eb-bc37-f344fce8469b",
    "storage_key": "property/6767906449167603/01a0102a-dea2-73eb-bc37-f344fce8469b.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "312",
  "property_year_built": "1987",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.23076923076923",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://millcreekwoodsapts.securecafeapplicant.com/onlineleasing/content3/access/millcreek-woods/floorplans",
  "property_resident_portal_url": "https://millcreekwoodsapts.securecafe.com/residentservices/millcreek-woods/userlogin.aspx",
  "property_apply_now_url": "https://millcreekwoodsapts.securecafeapplicant.com/onlineleasing/content3/access/millcreek-woods/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97d-69da-736e-bed3-6705cbacfa2d.webp",
  "property_primary_logo_media": {
    "alt_text": "Millcreek Woods Apartments logo",
    "public_id": "019fc97d-69da-736e-bed3-6705cbacfa2d",
    "storage_key": "property/6767906449167603/019fc97d-69da-736e-bed3-6705cbacfa2d.webp",
    "width": 1500,
    "height": 524
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-c842-71d1-90aa-d1f6add41e7f.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc97e-c842-71d1-90aa-d1f6add41e7f",
    "storage_key": "property/6767906449167603/019fc97e-c842-71d1-90aa-d1f6add41e7f.webp",
    "width": 1280,
    "height": 447
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-b38c-75ad-8e1d-cb3466986640.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc97e-b38c-75ad-8e1d-cb3466986640",
    "storage_key": "property/6767906449167603/019fc97e-b38c-75ad-8e1d-cb3466986640.webp",
    "width": 1280,
    "height": 447
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#004F59",
  "property_secondary_color": "#885053",
  "property_font_color": null,
  "property_color_4": "#EDB183",
  "property_color_3": "#75B8C8",
  "property_color_5": "#E3E7AF",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "370 - 970",
  "property_sqft_min": "370",
  "property_sqft_max": "970",
  "property_price_range": "887 - 3846",
  "property_price_min": "887",
  "property_price_max": "3846",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/MillcreekWoodsApts",
  "property_instagram_url": "https://www.instagram.com/millcreekwoods/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJqyJyremVwIcR2SgJarW04yA",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Millcreek Woods Apartment Homes",
  "property_home_romance_title": "Experience the Charm of Your New Apartment Community Today",
  "property_home_amenities_blurb": "<p><strong>Outdoor space, everyday ease, and polished apartment comforts.</strong> At Millcreek Woods Apartment Homes, amenities stretch from a one-mile nature trail and scenic lake to a swimming pool, sundeck, fitness center, and courts for tennis, basketball, and volleyball. Inside, enjoy practical features like spacious closets, air conditioning, high-speed internet readiness, and dishwasher-equipped kitchens, with select homes offering fireplaces, patios or balconies, stainless steel appliances, upgraded lighting, and stylish cabinetry.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio, one-, and two-bedroom layouts—made easy to compare.</strong> Millcreek Woods Apartment Homes offers Olathe floor plans with simple one-bath designs, spacious closets, air conditioning, dishwasher-equipped kitchens, and high-speed internet readiness. Select homes add extra polish with a fireplace, private patio or balcony, stainless steel appliances, upgraded lighting, and espresso or white cabinetry. Browse featured layouts, check current availability, and find the space that fits your day-to-day.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Millcreek Woods.</strong> Preview lakeside views with a fountain, an inviting pool deck, green-space-framed courts, and a clubhouse lounge with a coffee bar. Inside the Olathe apartments, spot clean-lined kitchens, stainless steel appliances in select homes, fireplace options, walk-in closets, and covered patio or balcony space made for a fresh-air finish.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Green space, Olathe convenience, and easy I-35 access.</strong> Millcreek Woods places you near the 119th Street corridor for everyday errands, dining, and shopping, with Olathe Station and Downtown Olathe just a quick drive away. Parks and the Mill Creek Streamway area add room to roam when you want time outside, all while the community keeps its calmer, tucked-away feel.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say the difference is in the care.</strong> Reviews highlight Millcreek Woods Apartment Homes for its calm setting, well-kept grounds, and responsive service from move-in onward. Look for praise of prompt maintenance, clear communication, clean lake views, outdoor spaces, the pool, fitness center, walking trail, and community events—plus feedback like “10/10 service” and “best value for your money.”</p>",
  "property_neighborhood_blurb": "<p><strong>Olathe convenience with a calmer Millcreek backdrop.</strong> From Millcreek Woods, you’re tucked near green space while staying close to the 119th Street corridor for daily stops, dinner plans, and easy I-35 connections. Map a quick drive to Olathe Station for AMC DINE-IN, Chuy’s, Sake, and shopping, or head toward Downtown Olathe for local cafés, breweries, and storefronts with a historic-square feel. When you want time outside, Washington School Park, Two Trails Park, and the Mill Creek Streamway area add more room to roam beyond the community’s own <a href=\"/amenities\">outdoor amenities</a>. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Millcreek Woods keeps everyday Olathe close without losing its tucked-away feel.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that give your day more room to breathe.</strong> At Millcreek Woods Apartment Homes, you can move from a morning workout to a quiet lap around the one-mile nature trail, then wind down by the scenic lake, swimming pool, or sundeck. Courts for tennis, basketball, and volleyball add more ways to get outside, while the clubhouse lounge, package service, on-site maintenance, and flexible online services help keep daily routines simple.</p><p>Inside your Olathe apartment, practical comforts pair with polished details: spacious closets, high-speed internet readiness, air conditioning, dishwasher-equipped kitchens, and select homes with a fireplace, private patio or balcony, stainless steel appliances, upgraded lighting, and espresso or white cabinetry. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Millcreek Woods home?</strong> Start your online application for a studio, one-, or two-bedroom apartment surrounded by green space, a scenic lake, and everyday Olathe convenience. Review <a href=\"/floor-plans\">available floor plans</a>, then take the next step with confidence.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Millcreek Woods?</strong> Our leasing team is here to help with availability, directions, and next steps. Reach out to learn more about our green, lake-adjacent Olathe setting, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community in person.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Millcreek Woods?</strong> Start here for helpful answers about the community, leasing, amenities, and everyday living in our green, lake-adjacent Olathe setting. If you need anything more specific, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> At Millcreek Woods Apartment Homes, you can compare studio, one-bedroom, and two-bedroom apartments in Olathe with simple one-bath designs and options that range from efficient and easy to comfortably roomy. As you browse available floor plans, look for the details that make each home feel complete: spacious closets, air conditioning, dishwasher-equipped kitchens, high-speed internet readiness, and select homes with a fireplace, private patio or balcony, stainless steel appliances, upgraded lighting, and espresso or white cabinetry.</p><p>Whether you want a streamlined studio or a two-bedroom home with extra room to spread out, the floor plan cards below make it easy to review current pricing, availability, and finishes. Explore more <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See Millcreek Woods from every angle.</strong> Browse photos that bring the community into focus: sunlight on the lake fountain, a pool deck made for easy afternoons, courts framed by open green space, and a clubhouse lounge with a coffee bar and room to settle in.</p><p>Inside, picture kitchens with clean-lined cabinetry and stainless steel appliances in select homes, living areas with ceiling fans and fireplace options, walk-in closets, and covered patio or balcony moments that extend your space outdoors. Let the gallery guide your first impression, then explore more <a href=\"/amenities\">featured amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience these Olathe apartments in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Millcreek Woods on the map.</strong> See available apartments near Ridgeview Road and 119th Street, then zoom out to nearby shopping, dining, recreation, and Olathe destinations—all from a green, lake-adjacent setting. Start with <a href=\"/floor-plans\">current floor plans</a> or explore the <a href=\"/neighborhood\">surrounding neighborhood</a>.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to roam.</strong> At Millcreek Woods Apartment Homes, approved dogs and cats can share in the easy rhythm of your day—from quick walks around the community to longer strolls along the one-mile nature trail beside the lake.</p><p>Inside, spacious layouts and select private patios or balconies give you comfortable places to settle in after time outside. As part of the Price Brothers Pet Royalty Club, pet-owning residents can also access local pet-related offers and services, adding extra convenience beyond your front door. Review the policy details on this page, then explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Millcreek Woods fits your Olathe pet routine.</p>",
  "property_referafriend_blurb": "<p><strong>Love the lake-adjacent setting at Millcreek Woods?</strong> Share the green space, one-mile nature trail, pool, clubhouse lounge, and connected Olathe convenience with a friend. Send a referral today and invite them to find their next studio, one-, or two-bedroom apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong> Log in to pay rent, submit maintenance requests, and manage your Millcreek Woods account—then get back to the green space, scenic lake, one-mile nature trail, and Olathe convenience that make home feel connected.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> In reviews for Millcreek Woods Apartment Homes, residents point to a calm setting, well-kept grounds, and service that feels responsive from move-in onward. One longtime resident says the property is “ALWAYS in top notch shape,” with prompt, professional maintenance and clear communication when questions come up.</p><p>As you read through the ratings, you’ll also see praise for the clean lake views, outdoor space, pool, fitness center, walking trail, and community events that add connection throughout the year. From “10/10 service” to “best value for your money,” the feedback highlights a community where care and consistency stand out.</p>",
  "property_created_at": "1785791806104",
  "property_scheduletour_blurb": "<p><strong>See Millcreek Woods in person.</strong> Tour the green, lake-adjacent setting, explore studio to two-bedroom layouts, and picture everyday comfort with spacious closets, dishwashers, and select fireplaces or patios. Schedule your visit today and experience the nature trail, pool, clubhouse, and connected Olathe convenience firsthand.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Millcreek Woods Apartment Homes.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture green space, a scenic lake, a one-mile nature trail, and connected Olathe convenience—then explore our <a href=\"/floor-plans\">available floor plans</a>.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Millcreek Woods Apartment Homes",
  "property_seo_title_home": "Millcreek Woods Apartment Homes |  Apartments in Olathe, KS",
  "property_seo_description_home": "Live in comfort at Millcreek Woods in Olathe, KS. Enjoy spacious floor plans, luxury amenities, and a scenic nature trail. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Olathe, KS Apartments for Rent",
  "property_seo_description_floorplans": "Discover your sanctuary at Millcreek Woods Apartments in Olathe, KS, with stylish studios and spacious one or two-bedroom layouts!",
  "property_seo_title_amenities": "Amenities | Olathe, KS Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and convenience at Millcreek Woods in Olathe, KS. Enjoy spacious floor plans, a state-of-the-art fitness center, and scenic nature trails!",
  "property_seo_title_gallery": "Gallery | Apartments in Olathe, KS",
  "property_seo_description_gallery": "Picture life at Millcreek Woods in Olathe, KS! Enjoy spacious floor plans, stunning amenities, scenic trails, and a vibrant community. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Millcreek Woods Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Millcreek Woods in Olathe, KS! Enjoy spacious studio, one, and two-bedroom layouts. Take a virtual tour and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Millcreek Woods Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Millcreek Woods in Olathe, KS! Check out our interactive community map to explore spacious apartments and enticing amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Olathe, KS",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle at Millcreek Woods in Olathe, KS. Uncover local favorites and connect with charming spots just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Millcreek Woods Apartment Homes",
  "property_seo_description_contact": "Find your perfect home at Millcreek Woods in Olathe, KS. From cozy studios to spacious two-bedrooms, our leasing team is here to help—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Olathe, KS",
  "property_seo_description_faqs": "Discover Millcreek Woods in Olathe, KS! Check our FAQs for info on amenities, floor plans, and the vibrant community life.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Olathe, KS",
  "property_seo_description_reviews": "Join the Millcreek Woods family in Olathe, KS! Our vibrant community offers top-notch amenities and resident-driven activities. See what our residents love!",
  "property_seo_title_applynow": "Apply Now | Apartments in Olathe, KS",
  "property_seo_description_applynow": "Experience Millcreek Woods in Olathe, KS—where modern living meets nature. Choose from spacious floor plans and enjoy top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Millcreek Woods Apartment Homes",
  "property_seo_description_residentaccess": "Access your Millcreek Woods portal to effortlessly pay rent, schedule maintenance, and manage your living experience in vibrant Olathe, KS.",
  "property_seo_title_referafriend": "Refer A Friend | Millcreek Woods Apartment Homes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Millcreek Woods Apartment Homes in Olathe, KS, and enjoy a thriving community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Millcreek Woods Apartment Homes",
  "property_seo_description_scheduletour": "Experience the charm of Millcreek Woods in Olathe, KS! Schedule a tour today and step into your future home surrounded by nature and modern comforts.",
  "property_seo_title_privacy": "Privacy Policy | Millcreek Woods Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at Millcreek Woods in Olathe, KS. Learn how we protect your information and ensure a secure, comfortable living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Millcreek Woods Apartment Homes",
  "property_seo_description_accessibility": "At Millcreek Woods in Olathe, KS, we prioritize digital accessibility, ensuring everyone can enjoy our vibrant community and exceptional living experience.",
  "property_seo_title_sitemap": "Sitemap | Millcreek Woods Apartment Homes",
  "property_seo_description_sitemap": "Uncover the layout of Millcreek Woods Apartment Homes in Olathe, KS. Access our sitemap for easy navigation and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Millcreek Woods Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to vibrant living at Millcreek Woods in Olathe begins now. Our team will connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Olathe, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628981688",
  "amenities": [
    {
      "id": "ec_97be4cba61725983789157fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847242",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-efae-7518-8f15-bdb39fe3dc7c.webp",
      "amenity_image_media": {
        "alt_text": "Lounge area with two sofas, a coffee table, and a TV, overlooking a kitchen with bar seating.",
        "public_id": "01a0102a-efae-7518-8f15-bdb39fe3dc7c",
        "storage_key": "property/6767906449167603/01a0102a-efae-7518-8f15-bdb39fe3dc7c.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Resident lounge with comfortable seating and access to clubhouse amenities.,Clubhouse kitchen featuring wood cabinetry, black appliances, and breakfast bar seating.,Coffee station with beverage supplies and resident refreshments inside the clubhouse.,Open clubhouse kitchen with ample counter space and adjacent resident gathering area.,Resident clubhouse seating area with coffee station and community gathering space.,Open clubhouse area with dining seating, natural light, and views of outdoor amenities.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3cf8cd2a5537ef93b30f4616",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847238",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-edb2-754e-88de-fc34f5d7d2ca.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor basketball court with two hoops and chain-link fencing.",
        "public_id": "01a0102a-edb2-754e-88de-fc34f5d7d2ca",
        "storage_key": "property/6767906449167603/01a0102a-edb2-754e-88de-fc34f5d7d2ca.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Fenced outdoor basketball court with a well-maintained playing surface at Millcreek Woods Apartment Homes.,Fenced outdoor basketball court with a well-maintained playing surface at Millcreek Woods Apartment Homes.,Outdoor basketball court surrounded by green lawn and mature trees at Millcreek Woods Apartment Homes.,Basketball court located adjacent to the community pool area and overlooking the lake at Millcreek Woods.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fd3301306a5eeb93efaf1f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847240",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-ed10-708b-ae74-40b31c4f1b62.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool and clubhouse at apartment complex",
        "public_id": "01a0102a-ed10-708b-ae74-40b31c4f1b62",
        "storage_key": "property/6767906449167603/01a0102a-ed10-708b-ae74-40b31c4f1b62.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Resort-style swimming pool with lounge chairs and the community clubhouse in the background.,Outdoor swimming pool with lounge seating and lake views at Millcreek Woods Apartment Homes.,Elevated view of the outdoor swimming pool featuring lounge seating and community gathering areas.,Elevated view of the swimming pool, sundeck, basketball court, and surrounding amenities at Millcreek Woods.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee65ac79b413c8662b41c6ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847239",
      "title": "Laundry Facility In Each Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3818bac9e8d5af2e65ff1424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87927396",
      "title": "Scenic Lake",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-ed5c-77c8-b347-f07fa8bcebe1.webp",
      "amenity_image_media": {
        "alt_text": "A serene lake with a fountain in the foreground and apartment buildings in the background under a blue sky with clouds.",
        "public_id": "01a0102a-ed5c-77c8-b347-f07fa8bcebe1",
        "storage_key": "property/6767906449167603/01a0102a-ed5c-77c8-b347-f07fa8bcebe1.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Waterfront lake with fountain surrounded by manicured grounds and residential buildings.,Decorative fountain in the community lake with apartment homes and mature trees nearby.,Lakefront view showcasing apartment homes, landscaped lawns, and waterfront scenery.,Drone view of the community lake, residential buildings, walking paths, and amenities.,Lakefront apartment homes overlooking the community fountain and walking trail.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09b4c84dd2a1500b3445942d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847243",
      "title": "One Mile Long Nature Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-edac-710f-9826-07e49eedef16.webp",
      "amenity_image_media": {
        "alt_text": "Walking path along a lake with a fountain and trees.",
        "public_id": "01a0102a-edac-710f-9826-07e49eedef16",
        "storage_key": "property/6767906449167603/01a0102a-edac-710f-9826-07e49eedef16.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Paved walking trail along the community lake with waterfront views and green space.,Community lake featuring a decorative fountain, shoreline landscaping, and mature trees.,Walking path crossing a landscaped creek near the community lake.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_453c3483c32e727effa5fc06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847244",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-10f7-73da-a615-2c4b973adbd1.webp",
      "amenity_image_media": {
        "alt_text": "Gym with cardio machines and weight rack",
        "public_id": "01a0102b-10f7-73da-a615-2c4b973adbd1",
        "storage_key": "property/6767906449167603/01a0102b-10f7-73da-a615-2c4b973adbd1.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "The gym at Millcreek Woods Apartments in Olathe, KS,Gym at Millcreek Woods Apartments in Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36ad3da506186d665df99275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847241",
      "title": "Storage Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69a8d8fc43bab283f99a6381",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "122755385",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_793ee2b8f110e82204b58e19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847247",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-fe27-77e6-ad0e-a56566ce0093.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a white sofa, coffee table, and a painting of a pier.",
        "public_id": "01a0102a-fe27-77e6-ad0e-a56566ce0093",
        "storage_key": "property/6767906449167603/01a0102a-fe27-77e6-ad0e-a56566ce0093.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a living room with a white couch and a ceiling fanat Millcreek Woods Apartments, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c696cbe1ce60798d9fa2c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847248",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-ff3b-763e-aaa4-7e283580bf7d.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a bed, dresser, and artwork.",
        "public_id": "01a0102a-ff3b-763e-aaa4-7e283580bf7d",
        "storage_key": "property/6767906449167603/01a0102a-ff3b-763e-aaa4-7e283580bf7d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a bedroom with a bed and a ceiling fanat Millcreek Woods Apartments, Kansas, 66061",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05af950499f86b93e0360aa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847250",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-002b-75a6-ad46-173aa6a806d9.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with a table and chairs, overlooking green trees and a bright sky.",
        "public_id": "01a0102b-002b-75a6-ad46-173aa6a806d9",
        "storage_key": "property/6767906449167603/01a0102b-002b-75a6-ad46-173aa6a806d9.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Covered patio featuring outdoor dining furniture, decorative planters, and sliding glass door access.,Spacious covered patio with outdoor seating, wood ceiling accents, and access to the apartment interior.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afe7b9f3f7f871f443ea6a32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847251",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3704f9c368b9e1fd8852ac4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847252",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-14bc-7550-8010-91149b5d0913.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dishwasher, sink, and counter space, opening to a living area.",
        "public_id": "01a0102b-14bc-7550-8010-91149b5d0913",
        "storage_key": "property/6767906449167603/01a0102b-14bc-7550-8010-91149b5d0913.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with a black dishwasher and a sink with a wooden cabinet.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baf8a8afa4f870c238249315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847249",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-0889-742e-a2d4-c580621bb7eb.webp",
      "amenity_image_media": {
        "alt_text": "Gas fireplace with tile surround and hearth in a living room.",
        "public_id": "01a0102b-0889-742e-a2d4-c580621bb7eb",
        "storage_key": "property/6767906449167603/01a0102b-0889-742e-a2d4-c580621bb7eb.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Tile-surround fireplace in a Millcreek Woods apartment home living area.,Open-concept living room featuring a fireplace, breakfast bar seating, and adjacent kitchen.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_245832538a5a67bb395a8284",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847253",
      "title": "High Speed Internet Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07814b52219d7e6065389c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87847254",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-0a8c-729a-a9d4-e5c56532e1f5.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with organized clothes and shoes",
        "public_id": "01a0102b-0a8c-729a-a9d4-e5c56532e1f5",
        "storage_key": "property/6767906449167603/01a0102b-0a8c-729a-a9d4-e5c56532e1f5.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Extended walk-in closet with hanging rods, shelving, and additional storage space.,Large walk-in closet with shelving, hanging storage, and room for organization.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac829d5f2f15e16b8cf65e49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "87901160",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-0d51-759b-8432-e7b81b9d2079.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with stainless steel appliances and wood cabinets.",
        "public_id": "01a0102b-0d51-759b-8432-e7b81b9d2079",
        "storage_key": "property/6767906449167603/01a0102b-0d51-759b-8432-e7b81b9d2079.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Apartment kitchen featuring stainless steel appliances, cabinetry, and ample countertop space.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c23a02d3eb5311f0bd97dad6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "122010755",
      "title": "White Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bad8edd0bfe552ea6905bd78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "122010758",
      "title": "Upgraded Light Fixtures*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ec334143aeb9ad10013eefb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "external_id": "122010759",
      "title": "Espresso Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_88c2cc2720781c2479391097",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-dea2-73eb-bc37-f344fce8469b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, chairs, coffee table, and kitchen with bar seating.",
        "public_id": "01a0102a-dea2-73eb-bc37-f344fce8469b",
        "storage_key": "property/6767906449167603/01a0102a-dea2-73eb-bc37-f344fce8469b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy living area featuring a fireplace, comfortable seating, and a breakfast bar connecting to the kitchen.",
      "link": "false",
      "alt_text": "Living room with fireplace, sofa, chairs, coffee table, and kitchen with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Staged-Photo_Apartment-Interior_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_68a93bda2b2eb8d31c9bfdb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-320c-7581-b885-40a0dc4d4bda.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sectional sofa, coffee table, and dining area.",
        "public_id": "01a0102b-320c-7581-b885-40a0dc4d4bda",
        "storage_key": "property/6767906449167603/01a0102b-320c-7581-b885-40a0dc4d4bda.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment featuring a spacious living area with a modern sectional sofa and a separate dining space, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room with a gray sectional sofa, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC06923_final.jpg"
    },
    {
      "id": "ec_95d3678cf8d566c9f483bde5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-327f-7522-8065-7fa834fb938e.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in apartment.",
        "public_id": "01a0102b-327f-7522-8065-7fa834fb938e",
        "storage_key": "property/6767906449167603/01a0102b-327f-7522-8065-7fa834fb938e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern dining area and kitchen with bar seating and ample cabinet space.",
      "link": "false",
      "alt_text": "Dining area and kitchen in apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC06908_final.jpg"
    },
    {
      "id": "ec_41e4c3323ccdc8cb5223cd44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-3273-74d8-bf36-b3d8e635a1a3.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, breakfast bar, and view into the kitchen and bathroom.",
        "public_id": "01a0102b-3273-74d8-bf36-b3d8e635a1a3",
        "storage_key": "property/6767906449167603/01a0102b-3273-74d8-bf36-b3d8e635a1a3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy a bright and airy dining space with a breakfast bar, perfect for casual meals or entertaining guests. The open layout connects seamlessly to the kitchen and bathroom.",
      "link": "false",
      "alt_text": "Dining area with a table and chairs, breakfast bar, and view into the kitchen and bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-DSC07003_final.jpg"
    },
    {
      "id": "ec_f68c32a6c66aa944808461ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-32cb-722d-ae3a-faf6997e9441.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment",
        "public_id": "01a0102b-32cb-722d-ae3a-faf6997e9441",
        "storage_key": "property/6767906449167603/01a0102b-32cb-722d-ae3a-faf6997e9441.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area and open-concept kitchen in an apartment. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-DSC06993_final.jpg"
    },
    {
      "id": "ec_d7e6a7a17d11b1fb8c9b9fb5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-3409-73fa-98af-0b35a6e81cb2.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, coffee table, and a painting of a pier on the wall.",
        "public_id": "01a0102b-3409-73fa-98af-0b35a6e81cb2",
        "storage_key": "property/6767906449167603/01a0102b-3409-73fa-98af-0b35a6e81cb2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable white sofa, a modern coffee table, and tasteful wall art, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room with a white sofa, coffee table, and a painting of a pier on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-DSC06988_final.jpg"
    },
    {
      "id": "ec_ed3b7d52081ec271ef8d43c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-3f3d-7418-a1a3-0b5e9d99f9d8.webp",
      "image_media": {
        "alt_text": "Living and dining area with white sofa, pink rug, dining table with chairs, and bar stools.",
        "public_id": "01a0102b-3f3d-7418-a1a3-0b5e9d99f9d8",
        "storage_key": "property/6767906449167603/01a0102b-3f3d-7418-a1a3-0b5e9d99f9d8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, a elegant dining set, and a breakfast bar, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living and dining area with white sofa, pink rug, dining table with chairs, and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/28-DSC07008_final.jpg"
    },
    {
      "id": "ec_84952d2bb3511dc93378e074",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-4207-7279-99fe-1f7998080439.webp",
      "image_media": {
        "alt_text": "Modern dining area with a table and chairs, and a kitchen pass-through.",
        "public_id": "01a0102b-4207-7279-99fe-1f7998080439",
        "storage_key": "property/6767906449167603/01a0102b-4207-7279-99fe-1f7998080439.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining area perfect for meals and entertaining. This space features a comfortable dining set and a convenient pass-through to the kitchen.",
      "link": "false",
      "alt_text": "Modern dining area with a table and chairs, and a kitchen pass-through.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-DSC06968_final.jpg"
    },
    {
      "id": "ec_c6af20412eec71b71ba496ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-0d51-759b-8432-e7b81b9d2079.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and wood cabinets.",
        "public_id": "01a0102b-0d51-759b-8432-e7b81b9d2079",
        "storage_key": "property/6767906449167603/01a0102b-0d51-759b-8432-e7b81b9d2079.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring stainless steel appliances, ample cabinet space, and a modern aesthetic.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Staged-Photo_Apartment-Interior_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_db2bf77ba7f9f903085dcc68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-419f-7214-8a12-6d5472ed0608.webp",
      "image_media": {
        "alt_text": "Black refrigerator, black oven, and double sink in a kitchen with white countertops and light wood cabinets.",
        "public_id": "01a0102b-419f-7214-8a12-6d5472ed0608",
        "storage_key": "property/6767906449167603/01a0102b-419f-7214-8a12-6d5472ed0608.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A view of the kitchen area, showcasing a black refrigerator, black oven, and double sink with white countertops and light wood cabinets.",
      "link": "false",
      "alt_text": "Black refrigerator, black oven, and double sink in a kitchen with white countertops and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-DSC07028.jpg"
    },
    {
      "id": "ec_75ec3c5133a953133e7cc6f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-42d3-707c-8cb3-fb945fbdf611.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances, white countertops, and wood-toned cabinets.",
        "public_id": "01a0102b-42d3-707c-8cb3-fb945fbdf611",
        "storage_key": "property/6767906449167603/01a0102b-42d3-707c-8cb3-fb945fbdf611.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring black appliances, ample cabinet storage, and a sleek design. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with black appliances, white countertops, and wood-toned cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-DSC07018_final.jpg"
    },
    {
      "id": "ec_e4cc830d74c52de2a214a0f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-4277-756f-a41f-3adb22c6c890.webp",
      "image_media": {
        "alt_text": "Kitchen with white countertops, a black dishwasher, and a view of the living room.",
        "public_id": "01a0102b-4277-756f-a41f-3adb22c6c890",
        "storage_key": "property/6767906449167603/01a0102b-4277-756f-a41f-3adb22c6c890.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a fully equipped kitchen with ample cabinet space, perfect for preparing meals. This open-concept design flows seamlessly into the living area.",
      "link": "false",
      "alt_text": "Kitchen with white countertops, a black dishwasher, and a view of the living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/35-DSC07048_final.jpg"
    },
    {
      "id": "ec_8027652c6f40049551b7b9a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-4c3c-73c4-9cf7-5f317ff51445.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white refrigerator, white stove, and microwave.",
        "public_id": "01a0102b-4c3c-73c4-9cf7-5f317ff51445",
        "storage_key": "property/6767906449167603/01a0102b-4c3c-73c4-9cf7-5f317ff51445.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample cabinet space, a full-size refrigerator, stove, and microwave. Perfect for everyday cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white refrigerator, white stove, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC06938_final.jpg"
    },
    {
      "id": "ec_b716577a0508c503d343000c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-4ed9-7415-b50f-7a632156a5d5.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, black stove and microwave, and wood cabinets.",
        "public_id": "01a0102b-4ed9-7415-b50f-7a632156a5d5",
        "storage_key": "property/6767906449167603/01a0102b-4ed9-7415-b50f-7a632156a5d5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Kitchen featuring a white refrigerator, a black electric stove with a white base, a microwave, and ample wood cabinetry for storage.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, black stove and microwave, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-DSC06964.jpg"
    },
    {
      "id": "ec_047ee4dc92b9b5d6df4f0e08",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-507a-74ba-bc7f-8015c6085525.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, teal bedding, nightstand, ceiling fan, and two pieces of abstract art.",
        "public_id": "01a0102b-507a-74ba-bc7f-8015c6085525",
        "storage_key": "property/6767906449167603/01a0102b-507a-74ba-bc7f-8015c6085525.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with teal bedding, a modern nightstand, a ceiling fan, and decorative wall art.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, teal bedding, nightstand, ceiling fan, and two pieces of abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-DSC06853(2)_final.jpg"
    },
    {
      "id": "ec_30b4526bc7ec73652188ce3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-502e-76dd-9a51-939a9640f3ac.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-sized bed, teal bedding, and abstract wall art.",
        "public_id": "01a0102b-502e-76dd-9a51-939a9640f3ac",
        "storage_key": "property/6767906449167603/01a0102b-502e-76dd-9a51-939a9640f3ac.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious bedroom, featuring a comfortable king-sized bed and stylish decor, perfect for a restful night's sleep.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-sized bed, teal bedding, and abstract wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-DSC06863_ver_final.jpg"
    },
    {
      "id": "ec_a9334fc3030d3c285dfc9ca6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-50fd-7269-9e1d-c4b2d553acd4.webp",
      "image_media": {
        "alt_text": "Bedroom with bed, dresser, ceiling fan, and abstract art.",
        "public_id": "01a0102b-50fd-7269-9e1d-c4b2d553acd4",
        "storage_key": "property/6767906449167603/01a0102b-50fd-7269-9e1d-c4b2d553acd4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a stylish dresser, and a ceiling fan for added comfort. The room is decorated with abstract art and a potted plant.",
      "link": "false",
      "alt_text": "Bedroom with bed, dresser, ceiling fan, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-DSC06853_final.jpg"
    },
    {
      "id": "ec_2ffa1bd565d44d785d1f1641",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-58e2-7511-a40a-a00836b1919e.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and artwork.",
        "public_id": "01a0102b-58e2-7511-a40a-a00836b1919e",
        "storage_key": "property/6767906449167603/01a0102b-58e2-7511-a40a-a00836b1919e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, stylish dresser, and decorative artwork, creating a relaxing atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DSC06863_final.jpg"
    },
    {
      "id": "ec_259edd28d2725d8559c3354a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-5b73-729f-b37d-32fca761cca7.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, bedside tables, artwork, and a ceiling fan.",
        "public_id": "01a0102b-5b73-729f-b37d-32fca761cca7",
        "storage_key": "property/6767906449167603/01a0102b-5b73-729f-b37d-32fca761cca7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms, featuring plush bedding, elegant decor, and a calming atmosphere.",
      "link": "false",
      "alt_text": "Modern bedroom with a queen-size bed, bedside tables, artwork, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-DSC06853_final alternate.jpg"
    },
    {
      "id": "ec_53732fea7786b7a34dcecd27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-5dc6-74df-9ace-ba70b0ca70d3.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and a modern dresser with artwork.",
        "public_id": "01a0102b-5dc6-74df-9ace-ba70b0ca70d3",
        "storage_key": "property/6767906449167603/01a0102b-5dc6-74df-9ace-ba70b0ca70d3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, modern dresser, and a large framed artwork. Offers ample space for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a ceiling fan and a modern dresser with artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DSC06863_final alternate.jpg"
    },
    {
      "id": "ec_479703d6e34bba1b530a21ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-5d0c-774a-b8ea-68326ee8fc66.webp",
      "image_media": {
        "alt_text": "Bathroom with a wooden vanity, toilet, and shower curtain.",
        "public_id": "01a0102b-5d0c-774a-b8ea-68326ee8fc66",
        "storage_key": "property/6767906449167603/01a0102b-5d0c-774a-b8ea-68326ee8fc66.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a wood vanity with ample storage, a toilet, and a shower with a decorative curtain.",
      "link": "false",
      "alt_text": "Bathroom with a wooden vanity, toilet, and shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-DSC06887_final.jpg"
    },
    {
      "id": "ec_343889c5c5a0dcd7eeaff06e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-5e9d-7718-a125-d6be3c6257ff.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and bathtub with shower curtain.",
        "public_id": "01a0102b-5e9d-7718-a125-d6be3c6257ff",
        "storage_key": "property/6767906449167603/01a0102b-5e9d-7718-a125-d6be3c6257ff.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/37-DSC07067_final.jpg"
    },
    {
      "id": "ec_50185ab4a936116abc2659d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-63a3-7731-8d65-943b4901e4d2.webp",
      "image_media": {
        "alt_text": "Walk-in closet with clothes on hangers, shelves with folded clothes and hats, and shoes on the floor.",
        "public_id": "01a0102b-63a3-7731-8d65-943b4901e4d2",
        "storage_key": "property/6767906449167603/01a0102b-63a3-7731-8d65-943b4901e4d2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample storage with shelving and hanging space, perfect for organizing your wardrobe. Includes decorative art and a mirror.",
      "link": "false",
      "alt_text": "Walk-in closet with clothes on hangers, shelves with folded clothes and hats, and shoes on the floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Staged-Photo_Apartment-Interior_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_2e95518cce72cb5418dc68fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-0a8c-729a-a9d4-e5c56532e1f5.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothes and shoes",
        "public_id": "01a0102b-0a8c-729a-a9d4-e5c56532e1f5",
        "storage_key": "property/6767906449167603/01a0102b-0a8c-729a-a9d4-e5c56532e1f5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space for all your clothing and accessories.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothes and shoes",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Staged-Photo_Apartment-Interior_2026-08-10_MLS-Size (4).jpg"
    },
    {
      "id": "ec_db4d57f4f55aaf9bb93f7aec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-0889-742e-a2d4-c580621bb7eb.webp",
      "image_media": {
        "alt_text": "Gas fireplace with tile surround and hearth in a living room.",
        "public_id": "01a0102b-0889-742e-a2d4-c580621bb7eb",
        "storage_key": "property/6767906449167603/01a0102b-0889-742e-a2d4-c580621bb7eb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy up by the fireplace. This inviting gas fireplace features a tile surround and hearth, perfect for adding warmth and ambiance to your living space.",
      "link": "false",
      "alt_text": "Gas fireplace with tile surround and hearth in a living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Apartment-Interior_Fireplace_2026-08-10_MLS-Size.jpg"
    },
    {
      "id": "ec_854d851c8f5fbf49c9a4de64",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-002b-75a6-ad46-173aa6a806d9.webp",
      "image_media": {
        "alt_text": "Balcony with a table and chairs, overlooking green trees and a bright sky.",
        "public_id": "01a0102b-002b-75a6-ad46-173aa6a806d9",
        "storage_key": "property/6767906449167603/01a0102b-002b-75a6-ad46-173aa6a806d9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this charming balcony, furnished with a table and chairs, offering a peaceful view of the surrounding greenery.",
      "link": "false",
      "alt_text": "Balcony with a table and chairs, overlooking green trees and a bright sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Staged-Photo_Patio-Balcony_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_cce5c62513bd1fba3354c0fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-69fb-75eb-a431-990deea08349.webp",
      "image_media": {
        "alt_text": "Balcony with a table and chairs, overlooking trees and building.",
        "public_id": "01a0102b-69fb-75eb-a431-990deea08349",
        "storage_key": "property/6767906449167603/01a0102b-69fb-75eb-a431-990deea08349.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy outdoor dining and relaxation on your private balcony, featuring a table and chairs perfect for taking in the surrounding views.",
      "link": "false",
      "alt_text": "Balcony with a table and chairs, overlooking trees and building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Staged-Photo_Patio-Balcony_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_619a6bb728a538ccac145d3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-6ac8-73ed-88ec-86a5500f034e.webp",
      "image_media": {
        "alt_text": "Serene pond with a fountain in the middle, surrounded by lush green trees and vegetation.",
        "public_id": "01a0102b-6ac8-73ed-88ec-86a5500f034e",
        "storage_key": "property/6767906449167603/01a0102b-6ac8-73ed-88ec-86a5500f034e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the tranquil beauty of our community's pond, featuring a refreshing fountain and surrounded by abundant greenery.",
      "link": "false",
      "alt_text": "Serene pond with a fountain in the middle, surrounded by lush green trees and vegetation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (11).jpg"
    },
    {
      "id": "ec_63b13aa5be87dfcc7f525291",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-6c35-76a2-9354-e56ddc89906e.webp",
      "image_media": {
        "alt_text": "Damaged concrete path leading to a river with lush green trees and foliage surrounding it.",
        "public_id": "01a0102b-6c35-76a2-9354-e56ddc89906e",
        "storage_key": "property/6767906449167603/01a0102b-6c35-76a2-9354-e56ddc89906e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Explore the scenic natural beauty surrounding the community, with a serene river and abundant greenery offering a peaceful escape.",
      "link": "false",
      "alt_text": "Damaged concrete path leading to a river with lush green trees and foliage surrounding it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_3366301e36e0eaffa0eb6857",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-edac-710f-9826-07e49eedef16.webp",
      "image_media": {
        "alt_text": "Walking path along a lake with a fountain and trees.",
        "public_id": "01a0102a-edac-710f-9826-07e49eedef16",
        "storage_key": "property/6767906449167603/01a0102a-edac-710f-9826-07e49eedef16.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a stroll along the scenic walking path beside the tranquil lake, complete with a soothing fountain. A perfect spot for outdoor relaxation.",
      "link": "false",
      "alt_text": "Walking path along a lake with a fountain and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (4).jpg"
    },
    {
      "id": "ec_4fc48f09ee06a18dadd6ffc1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-6bf8-736d-9663-50a1570eb5d9.webp",
      "image_media": {
        "alt_text": "Apartment buildings overlooking a lake with a fountain.",
        "public_id": "01a0102b-6bf8-736d-9663-50a1570eb5d9",
        "storage_key": "property/6767906449167603/01a0102b-6bf8-736d-9663-50a1570eb5d9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Experience serene living with beautiful lake views and a calming fountain at our community. Enjoy the picturesque scenery right outside your door.",
      "link": "false",
      "alt_text": "Apartment buildings overlooking a lake with a fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_92d4bda499b873f8e9f6baab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-6fbc-7746-bd4a-5e76da412460.webp",
      "image_media": {
        "alt_text": "Apartment buildings overlooking a pond with a fountain.",
        "public_id": "01a0102b-6fbc-7746-bd4a-5e76da412460",
        "storage_key": "property/6767906449167603/01a0102b-6fbc-7746-bd4a-5e76da412460.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience serene living with our beautiful apartment buildings set against a picturesque pond and lush green landscape.",
      "link": "false",
      "alt_text": "Apartment buildings overlooking a pond with a fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (7).jpg"
    },
    {
      "id": "ec_3e526b403d6915ef3f836fe5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-77de-768d-b607-49b2b7996e6d.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a lake and fountain in front.",
        "public_id": "01a0102b-77de-768d-b607-49b2b7996e6d",
        "storage_key": "property/6767906449167603/01a0102b-77de-768d-b607-49b2b7996e6d.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Beautiful lake with a fountain, providing a scenic view for the surrounding apartment buildings.",
      "link": "false",
      "alt_text": "Apartment buildings with a lake and fountain in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (5).jpg"
    },
    {
      "id": "ec_399d20efa7dae32cc194a016",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-79aa-7386-86f8-94cafccb848d.webp",
      "image_media": {
        "alt_text": "Apartment buildings on a grassy hill overlooking a large blue lake with a fountain.",
        "public_id": "01a0102b-79aa-7386-86f8-94cafccb848d",
        "storage_key": "property/6767906449167603/01a0102b-79aa-7386-86f8-94cafccb848d.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience serene lakeside living with picturesque views of the water and lush green surroundings. This community offers a tranquil escape.",
      "link": "false",
      "alt_text": "Apartment buildings on a grassy hill overlooking a large blue lake with a fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (9).jpg"
    },
    {
      "id": "ec_d102a4020da4287daf8d7f8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-edb2-754e-88de-fc34f5d7d2ca.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with two hoops and chain-link fencing.",
        "public_id": "01a0102a-edb2-754e-88de-fc34f5d7d2ca",
        "storage_key": "property/6767906449167603/01a0102a-edb2-754e-88de-fc34f5d7d2ca.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our outdoor court, perfect for residents of all ages.",
      "link": "false",
      "alt_text": "Outdoor basketball court with two hoops and chain-link fencing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Basketball-Court_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_e68282b20437be65a39c24a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-7b8e-7786-8125-1b2244eafa82.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with fencing and a building in the background.",
        "public_id": "01a0102b-7b8e-7786-8125-1b2244eafa82",
        "storage_key": "property/6767906449167603/01a0102b-7b8e-7786-8125-1b2244eafa82.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a friendly game on our outdoor basketball court, perfect for staying active and having fun.",
      "link": "false",
      "alt_text": "Outdoor basketball court with fencing and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Basketball-Court_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_0c452a8d3446614bc43e37c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-7d6f-74aa-87dd-c46d738279cb.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court and picnic area with apartments in the background.",
        "public_id": "01a0102b-7d6f-74aa-87dd-c46d738279cb",
        "storage_key": "property/6767906449167603/01a0102b-7d6f-74aa-87dd-c46d738279cb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at the basketball court and picnic area, surrounded by lush greenery and apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor basketball court and picnic area with apartments in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Basketball-Court_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_9f93f49ff7bb4a01c633cca6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-7d11-7445-b432-73f983c0bc86.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and clubhouse at a multifamily property.",
        "public_id": "01a0102b-7d11-7445-b432-73f983c0bc86",
        "storage_key": "property/6767906449167603/01a0102b-7d11-7445-b432-73f983c0bc86.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, or relax by the clubhouse.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and clubhouse at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Pool_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_9377be460f1ea60adf2f4ed0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-9742-7075-bb92-d725b72da633.webp",
      "image_media": {
        "alt_text": "Community pool area with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0102b-9742-7075-bb92-d725b72da633",
        "storage_key": "property/6767906449167603/01a0102b-9742-7075-bb92-d725b72da633.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our sparkling community pool, complete with comfortable lounge chairs for soaking up the sun. Enjoy the resort-style amenities at your new home.",
      "link": "false",
      "alt_text": "Community pool area with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-1711 N Ridgeview Rd-3.jpg"
    },
    {
      "id": "ec_f9480ca103da3fbe782ca3a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-9be3-7144-b6cd-57350ca84c27.webp",
      "image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0102b-9be3-7144-b6cd-57350ca84c27",
        "storage_key": "property/6767906449167603/01a0102b-9be3-7144-b6cd-57350ca84c27.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Beautiful outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-1711 N Ridgeview Rd-4.jpg"
    },
    {
      "id": "ec_d19836fc2f5a1cf6059cb994",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-ed10-708b-ae74-40b31c4f1b62.webp",
      "image_media": {
        "alt_text": "Swimming pool and clubhouse at apartment complex",
        "public_id": "01a0102a-ed10-708b-ae74-40b31c4f1b62",
        "storage_key": "property/6767906449167603/01a0102a-ed10-708b-ae74-40b31c4f1b62.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool or relax on a lounge chair. The clubhouse offers a convenient space for residents.",
      "link": "false",
      "alt_text": "Swimming pool and clubhouse at apartment complex",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Pool_2026-08-10_MLS-Size (4).jpg"
    },
    {
      "id": "ec_1631a99b436b92945fa4dc10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-8b48-74a1-8a91-3b47d60ca2ad.webp",
      "image_media": {
        "alt_text": "Swimming pool and apartment buildings",
        "public_id": "01a0102b-8b48-74a1-8a91-3b47d60ca2ad",
        "storage_key": "property/6767906449167603/01a0102b-8b48-74a1-8a91-3b47d60ca2ad.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Outdoor swimming pool with lounge chairs and tables, surrounded by apartment buildings and landscaping.",
      "link": "false",
      "alt_text": "Swimming pool and apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Pool_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_f6b005cdd94fe6ecbcc3f15d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-8b34-7765-abc6-0780435ba294.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and tennis courts with a clubhouse at a multifamily property.",
        "public_id": "01a0102b-8b34-7765-abc6-0780435ba294",
        "storage_key": "property/6767906449167603/01a0102b-8b34-7765-abc6-0780435ba294.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool or a game of tennis. The clubhouse offers a great space for relaxation and socializing.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and tennis courts with a clubhouse at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Pool_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_b89816967cf54dbfcb80bc39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-8ca5-76a1-899e-3e416b137793.webp",
      "image_media": {
        "alt_text": "A clubhouse with a deck and grill sits near a tennis court and parking area at a multifamily property.",
        "public_id": "01a0102b-8ca5-76a1-899e-3e416b137793",
        "storage_key": "property/6767906449167603/01a0102b-8ca5-76a1-899e-3e416b137793.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy the amenities at this multifamily property, including a clubhouse with a deck and grill, and nearby tennis courts.",
      "link": "false",
      "alt_text": "A clubhouse with a deck and grill sits near a tennis court and parking area at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Pool-Deck_2026-08-10_Original-Size (2).jpg"
    },
    {
      "id": "ec_55fa5777558081b7b557913a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-985e-7598-ab76-2432b483eed7.webp",
      "image_media": {
        "alt_text": "Deck with outdoor grill, seating, and view of lake and apartment buildings.",
        "public_id": "01a0102b-985e-7598-ab76-2432b483eed7",
        "storage_key": "property/6767906449167603/01a0102b-985e-7598-ab76-2432b483eed7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor living on your private deck with a grill and seating, overlooking the lake and community buildings.",
      "link": "false",
      "alt_text": "Deck with outdoor grill, seating, and view of lake and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Amenities_Pool-Deck_2026-08-10_Original-Size (1).jpg"
    },
    {
      "id": "ec_ca9c7b69fb04859fa061adc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-bbc0-74db-9f22-646a1cd1cde8.webp",
      "image_media": {
        "alt_text": "Deck with a table and chairs, overlooking greenery.",
        "public_id": "01a0102b-bbc0-74db-9f22-646a1cd1cde8",
        "storage_key": "property/6767906449167603/01a0102b-bbc0-74db-9f22-646a1cd1cde8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining on the spacious deck, surrounded by lush trees and scenic views.",
      "link": "false",
      "alt_text": "Deck with a table and chairs, overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-1711 N Ridgeview Rd-17.jpg"
    },
    {
      "id": "ec_e6d8cecb0d44f5c016b436a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-9b17-74bf-b12b-0e7f9ba6bf33.webp",
      "image_media": {
        "alt_text": "Exterior view of a pool area entrance with landscaping and decorative lighting.",
        "public_id": "01a0102b-9b17-74bf-b12b-0e7f9ba6bf33",
        "storage_key": "property/6767906449167603/01a0102b-9b17-74bf-b12b-0e7f9ba6bf33.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped entrance to our community pool, featuring vibrant flowers and elegant lighting for a welcoming ambiance.",
      "link": "false",
      "alt_text": "Exterior view of a pool area entrance with landscaping and decorative lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Leasing-Office-Entrance_2026-08-10_MLS-Size.jpg"
    },
    {
      "id": "ec_dabe544714c8f128d947c8d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-a98f-73d1-a9ce-14b364017734.webp",
      "image_media": {
        "alt_text": "Aerial view of a community featuring a swimming pool, basketball court, and parking areas.",
        "public_id": "01a0102b-a98f-73d1-a9ce-14b364017734",
        "storage_key": "property/6767906449167603/01a0102b-a98f-73d1-a9ce-14b364017734.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Discover the amenities at our community, including a refreshing swimming pool and a recreational basketball court, all set within beautifully maintained grounds.",
      "link": "false",
      "alt_text": "Aerial view of a community featuring a swimming pool, basketball court, and parking areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Aerial-Drone_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_830d7ed8c3d5bf6103a4240d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-c54b-70ee-b3d4-ba27f64f6429.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight machines, and free weights.",
        "public_id": "01a0102b-c54b-70ee-b3d4-ba27f64f6429",
        "storage_key": "property/6767906449167603/01a0102b-c54b-70ee-b3d4-ba27f64f6429.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio and weight training equipment for residents to enjoy.",
      "link": "false",
      "alt_text": "Gym with cardio machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-1711 N Ridgeview Rd-2.jpg"
    },
    {
      "id": "ec_87db7901ba00e445a3b1dd76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-d1e4-77dc-a371-37a62fbd6896.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and cardio equipment.",
        "public_id": "01a0102b-d1e4-77dc-a371-37a62fbd6896",
        "storage_key": "property/6767906449167603/01a0102b-d1e4-77dc-a371-37a62fbd6896.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a wide range of cardio machines, weight training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, dumbbells, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-1711 N Ridgeview Rd-1.jpg"
    },
    {
      "id": "ec_3f0eac7f81b18d3081638ea4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102a-efae-7518-8f15-bdb39fe3dc7c.webp",
      "image_media": {
        "alt_text": "Lounge area with two sofas, a coffee table, and a TV, overlooking a kitchen with bar seating.",
        "public_id": "01a0102a-efae-7518-8f15-bdb39fe3dc7c",
        "storage_key": "property/6767906449167603/01a0102a-efae-7518-8f15-bdb39fe3dc7c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious lounge area, perfect for socializing or enjoying a quiet moment. Adjacent full-service kitchen and bar seating available.",
      "link": "false",
      "alt_text": "Lounge area with two sofas, a coffee table, and a TV, overlooking a kitchen with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Clubhouse-Interior_2026-08-10_MLS-Size (5).jpg"
    },
    {
      "id": "ec_321a10aaf83eb5ed6b4eecc0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-c16e-710b-b6eb-01ef76ce4bfe.webp",
      "image_media": {
        "alt_text": "Coffee bar in the community lounge with Keurig coffee maker and assorted pods.",
        "public_id": "01a0102b-c16e-710b-b6eb-01ef76ce4bfe",
        "storage_key": "property/6767906449167603/01a0102b-c16e-710b-b6eb-01ef76ce4bfe.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a complimentary coffee from our community coffee bar, available daily in the resident lounge.",
      "link": "false",
      "alt_text": "Coffee bar in the community lounge with Keurig coffee maker and assorted pods.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Clubhouse-Interior_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_836fafac97fdb13250235353",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-c16d-70cd-82e2-639564703e89.webp",
      "image_media": {
        "alt_text": "Community kitchen area with dining table and chairs.",
        "public_id": "01a0102b-c16d-70cd-82e2-639564703e89",
        "storage_key": "property/6767906449167603/01a0102b-c16d-70cd-82e2-639564703e89.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy cooking and dining in our spacious community kitchen, perfect for gatherings and events.",
      "link": "false",
      "alt_text": "Community kitchen area with dining table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Clubhouse-Interior_2026-08-10_MLS-Size (6).jpg"
    },
    {
      "id": "ec_ec95d7affe7c3e730d2d3755",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-d611-71df-8584-5cbffeb5c422.webp",
      "image_media": {
        "alt_text": "Communal lounge area with a large dining table, sofas, and large windows overlooking the grounds.",
        "public_id": "01a0102b-d611-71df-8584-5cbffeb5c422",
        "storage_key": "property/6767906449167603/01a0102b-d611-71df-8584-5cbffeb5c422.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our spacious communal lounge, perfect for gatherings or quiet work, featuring comfortable seating and a large dining table.",
      "link": "false",
      "alt_text": "Communal lounge area with a large dining table, sofas, and large windows overlooking the grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Clubhouse-Interior_2026-08-10_MLS-Size (4).jpg"
    },
    {
      "id": "ec_37d8f9a85cb41fd70e9fff76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-d232-70cd-97b2-7dba9c2f7c9e.webp",
      "image_media": {
        "alt_text": "Kitchen counter with bar stools, wooden cabinets, black appliances, and a refrigerator.",
        "public_id": "01a0102b-d232-70cd-97b2-7dba9c2f7c9e",
        "storage_key": "property/6767906449167603/01a0102b-d232-70cd-97b2-7dba9c2f7c9e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring a large counter with bar stools, ample cabinet space, and modern black appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen counter with bar stools, wooden cabinets, black appliances, and a refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Clubhouse-Interior_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_7061230a0b5b094de1e72062",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-e5b4-7156-ab44-d07b9bc5164f.webp",
      "image_media": {
        "alt_text": "Community coffee bar with seating",
        "public_id": "01a0102b-e5b4-7156-ab44-d07b9bc5164f",
        "storage_key": "property/6767906449167603/01a0102b-e5b4-7156-ab44-d07b9bc5164f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a fresh cup of coffee from our community coffee bar, complete with comfortable seating and a selection of amenities.",
      "link": "false",
      "alt_text": "Community coffee bar with seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Clubhouse-Interior_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_415a60297280ac4c03fe124c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-e8eb-71cf-a822-8538b225227f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts",
        "public_id": "01a0102b-e8eb-71cf-a822-8538b225227f",
        "storage_key": "property/6767906449167603/01a0102b-e8eb-71cf-a822-8538b225227f.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience resort-style living at our community, featuring a sparkling swimming pool and recreational amenities.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with pool and tennis courts",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Residential-Buildings_2026-08-10_MLS-Size (3).jpg"
    },
    {
      "id": "ec_4d8975ed43c189dec973df3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-ed20-73ba-bb00-3c9ec39822b1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and a lake in the background.",
        "public_id": "01a0102b-ed20-73ba-bb00-3c9ec39822b1",
        "storage_key": "property/6767906449167603/01a0102b-ed20-73ba-bb00-3c9ec39822b1.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing balconies and proximity to a serene lake.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with balconies and a lake in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Residential-Buildings_2026-08-10_MLS-Size (4).jpg"
    },
    {
      "id": "ec_6231e0fce4e92dab129e4512",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-f445-73f9-94e7-1c6440ea3e9f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, surrounded by green grass and trees under a blue sky.",
        "public_id": "01a0102b-f445-73f9-94e7-1c6440ea3e9f",
        "storage_key": "property/6767906449167603/01a0102b-f445-73f9-94e7-1c6440ea3e9f.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds and exterior architecture of the apartment complex, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies, surrounded by green grass and trees under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Residential-Buildings_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_b8e18b51a74915fdf8272ad5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-f441-71b1-9765-c253cead2461.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a lake and trees in the background.",
        "public_id": "01a0102b-f441-71b1-9765-c253cead2461",
        "storage_key": "property/6767906449167603/01a0102b-f441-71b1-9765-c253cead2461.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Apartment buildings overlooking a serene lake, surrounded by lush greenery and mature trees, offering a peaceful community setting.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a lake and trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Residential-Buildings_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_33b28c4592fd4fa0fed6cdc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-f9a9-77fa-a88a-8a61be7d8742.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a pond with a swimming pool and sports court.",
        "public_id": "01a0102b-f9a9-77fa-a88a-8a61be7d8742",
        "storage_key": "property/6767906449167603/01a0102b-f9a9-77fa-a88a-8a61be7d8742.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience lakeside living with our beautiful apartment community, featuring a sparkling pool, sports courts, and lush green spaces.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings surrounding a pond with a swimming pool and sports court.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Exterior_Lake_2026-08-10_MLS-Size (6).jpg"
    },
    {
      "id": "ec_a3019e9933eb23f32382dfbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-f95f-773e-b28b-a97023b2bce3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a serene lake, with a nearby suburban neighborhood.",
        "public_id": "01a0102b-f95f-773e-b28b-a97023b2bce3",
        "storage_key": "property/6767906449167603/01a0102b-f95f-773e-b28b-a97023b2bce3.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Discover tranquil living with this aerial view showcasing apartment buildings nestled around a beautiful lake, offering a peaceful retreat adjacent to a charming suburban neighborhood.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings surrounding a serene lake, with a nearby suburban neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Aerial-Drone_2026-08-10_MLS-Size (4).jpg"
    },
    {
      "id": "ec_c7759d495bed6b667819ee76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-fb9e-713a-a6cf-2fcf2221feaa.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pond and surrounding neighborhood.",
        "public_id": "01a0102b-fb9e-713a-a6cf-2fcf2221feaa",
        "storage_key": "property/6767906449167603/01a0102b-fb9e-713a-a6cf-2fcf2221feaa.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "An aerial view showcases the apartment complex, its surrounding pond, and the neighborhood's layout.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a pond and surrounding neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Aerial-Drone_2026-08-10_MLS-Size (2).jpg"
    },
    {
      "id": "ec_ada1e488c5dc58ce92b30cf9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-00b9-73ab-923a-10c4a9bd3937.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, a lake, and surrounding neighborhood with roads and trees.",
        "public_id": "01a0102c-00b9-73ab-923a-10c4a9bd3937",
        "storage_key": "property/6767906449167603/01a0102c-00b9-73ab-923a-10c4a9bd3937.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing apartment complexes nestled beside a serene lake, bordered by lush greenery and a suburban neighborhood. Roads and commercial areas are visible in the distance.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings, a lake, and surrounding neighborhood with roads and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Aerial-Drone_2026-08-10_MLS-Size (1).jpg"
    },
    {
      "id": "ec_6ed02e29ef52297d5ebcb1b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-0704-72da-aae4-c0436e2ae7bd.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with apartment buildings, houses, and a pond.",
        "public_id": "01a0102c-0704-72da-aae4-c0436e2ae7bd",
        "storage_key": "property/6767906449167603/01a0102c-0704-72da-aae4-c0436e2ae7bd.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "An aerial view showcases a well-maintained suburban community, featuring apartment complexes, residential housing, a serene pond, and surrounding green spaces.",
      "link": "false",
      "alt_text": "Aerial view of a suburban neighborhood with apartment buildings, houses, and a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Millcreek-Woods-020_Photo_Aerial-Drone_2026-08-10_MLS-Size (5).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9cab8f83-856f-4e32-99dc-78546c0550be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Johnny's Tavern Ridgeview",
      "poi_type": "Restaurants",
      "poi_address": "10384 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Branch of a local tavern chain (open since 1953) with pub food & TVs for sports.",
      "poi_long_description": "Branch of a local tavern chain (open since 1953) with pub food & TVs for sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-b1a9-708c-b474-6103023433da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-b1a9-708c-b474-6103023433da",
        "storage_key": "property/6767906449167603/019fc981-b1a9-708c-b474-6103023433da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.johnnystavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8915364779837114341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnnys-tavern-ridgeview",
      "poi_latitude": "38.9402347",
      "poi_longitude": "-94.7981465",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-378-0744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-e2e4-7251-a657-5e9505ca9ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01014-e2e4-7251-a657-5e9505ca9ac9",
        "storage_key": "property/6767906449167603/01a01014-e2e4-7251-a657-5e9505ca9ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ1M8aDCUwIcR5Uc4GQi9uXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_38a37ff5-0229-41f9-bffa-a9a8d4482e3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Goodcents",
      "poi_type": "Restaurants",
      "poi_address": "10432 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Cold & hot subs, pastas & salads fill out the menu at this simple, counter-serve chain.",
      "poi_long_description": "Cold & hot subs, pastas & salads fill out the menu at this simple, counter-serve chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b2-b21e-703d-aefc-92f069a5393b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-b21e-703d-aefc-92f069a5393b",
        "storage_key": "property/6767906449167603/019ff6b2-b21e-703d-aefc-92f069a5393b.webp",
        "width": 1280,
        "height": 1068
      },
      "poi_business_url": "https://locations.goodcentssubs.com/en-us/us/ks/olathe/10432-s-ridgeview-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15304556237185789206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodcents",
      "poi_latitude": "38.939495",
      "poi_longitude": "-94.7983779",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-894-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBeO2UjCUwIcRFq1yis-0ZNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_3a126dc5-b5ad-4b99-8d92-6509ff28f495",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Burger Shed at Embassy Suites Olathe",
      "poi_type": "Restaurants",
      "poi_address": "10401 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Fries, burgers, steaks and milkshakes are served at this casual restaurant and bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b2-af60-70ea-a5db-65469d1c7fb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-af60-70ea-a5db-65469d1c7fb7",
        "storage_key": "property/6767906449167603/019ff6b2-af60-70ea-a5db-65469d1c7fb7.webp",
        "width": 1116,
        "height": 1280
      },
      "poi_business_url": "https://eatatburgershed.com/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363867710375219928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burger-shed-at-embassy-suites-olathe",
      "poi_latitude": "38.9393686",
      "poi_longitude": "-94.7965957",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-353-9335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI7z4TV6VwIcR2FKK3XRu7RI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_54a182cc-8c81-4289-8d8e-0331cdb5f80f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "The Rub Bar-B-Que and Catering",
      "poi_type": "Restaurants",
      "poi_address": "10512 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Barbecue platters & sandwiches plus all the fixings served in a bright quick-serve establishment.",
      "poi_long_description": "Barbecue platters & sandwiches plus all the fixings served in a bright quick-serve establishment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc980-c345-701d-a194-48acc7d83112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-c345-701d-a194-48acc7d83112",
        "storage_key": "property/6767906449167603/019fc980-c345-701d-a194-48acc7d83112.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "http://www.therubbarbque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8919778289550225681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rub-bar-b-que-and-catering",
      "poi_latitude": "38.9379445",
      "poi_longitude": "-94.79820970000002",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-894-1820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9LqpDGUwIcREfHhZxhryXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_146ed221-51cf-4986-b67c-144585d3c824",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Minsky's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "10540 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Elevated pizzeria chain with lots of crust & topping options, plus spaghetti & cheesesteaks.",
      "poi_long_description": "Elevated pizzeria chain with lots of crust & topping options, plus spaghetti & cheesesteaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc980-dd92-7798-9645-9ed8d2ed5f9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-dd92-7798-9645-9ed8d2ed5f9b",
        "storage_key": "property/6767906449167603/019fc980-dd92-7798-9645-9ed8d2ed5f9b.webp",
        "width": 1280,
        "height": 789
      },
      "poi_business_url": "https://minskys.com/olathe-ridgeview/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9263467116710715238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minskys-pizza",
      "poi_latitude": "38.9377016",
      "poi_longitude": "-94.7982057",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-261-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZLatqCVwIcRZt8NQENyjoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_4f39cadb-0afc-4268-bcb4-68a69eff3887",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Golden Palace Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1711 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Long-running Chinese eatery serving classic meals in an unassuming, traditional space.",
      "poi_long_description": "Long-running Chinese eatery serving classic meals in an unassuming, traditional space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-ac6c-71df-ba0a-ea30a69a7bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-ac6c-71df-ba0a-ea30a69a7bf1",
        "storage_key": "property/6767906449167603/01a01014-ac6c-71df-ba0a-ea30a69a7bf1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.goldenpalaceks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15371849164436339653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-palace-chinese-restaurant",
      "poi_latitude": "38.8560624",
      "poi_longitude": "-94.7805921",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-780-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdlrnlq-wIcRxfscG1_HU9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_3d22d91f-3cf0-48ad-9738-bf9ce51d79b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "1731 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Long-standing bar and grill serving burgers, wraps, sandwiches, salads, nachos and chicken wings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b2-be34-72e3-8b9f-2ba9a2b2dbb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-be34-72e3-8b9f-2ba9a2b2dbb9",
        "storage_key": "property/6767906449167603/019ff6b2-be34-72e3-8b9f-2ba9a2b2dbb9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://peanutmidwest.com/the-peanut-on-s-mur-len-rd-olathe-ks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13303166440226011406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "38.8556625",
      "poi_longitude": "-94.7804693",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-839-1579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrz1Z_2S_wIcRDrmR6WRXnrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b579ee4d-1a02-455d-ac0a-1bdb2b4ebfcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "2027 E Santa Fe St, Olathe, KS 66062, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-a6a3-74b9-9ce1-85abe787362a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-a6a3-74b9-9ce1-85abe787362a",
        "storage_key": "property/6767906449167603/01a01014-a6a3-74b9-9ce1-85abe787362a.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6705633657294013365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scooters-coffee",
      "poi_latitude": "38.8833873",
      "poi_longitude": "-94.781557",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-283-8576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe1-75b9-9d99-116d98caac81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe1-75b9-9d99-116d98caac81",
        "storage_key": "property/6767906449167603/019ff6b3-2fe1-75b9-9d99-116d98caac81.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJrVfGNSS-wIcRtcPpiEgyD10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_0e9de868-fdef-48b3-9fff-758c1575109e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Bonito Michoacán",
      "poi_type": "Restaurants",
      "poi_address": "1231 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Butcher shop, bakery and store selling Mexican meat cuts, plus tacos and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc980-d2a6-77ff-9a67-8e046f07439f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-d2a6-77ff-9a67-8e046f07439f",
        "storage_key": "property/6767906449167603/019fc980-d2a6-77ff-9a67-8e046f07439f.webp",
        "width": 639,
        "height": 640
      },
      "poi_business_url": "http://bonitomichoacán.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800372171173904509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonito-michoacn",
      "poi_latitude": "38.8827407",
      "poi_longitude": "-94.7976309",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-768-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcX2Chu-wIcRfcDJlcYyRts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_615a715b-ede6-48d9-8337-36246e4f629c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Daylight Donuts - Olathe South 151st Street",
      "poi_type": "Restaurants",
      "poi_address": "1501 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Bakery turning out fresh donuts and kolaches, plus sandwiches and drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-b065-7328-a0ec-05d362ec4114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-b065-7328-a0ec-05d362ec4114",
        "storage_key": "property/6767906449167603/019fc981-b065-7328-a0ec-05d362ec4114.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4205359320504124514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daylight-donuts---olathe-south-151st-street",
      "poi_latitude": "38.8536608",
      "poi_longitude": "-94.7952321",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-839-3340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJf5Yy7O_wIcRYsSGYwVwXDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_437ae616-b87e-49fc-be5c-0243c6706f32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Emiliano's Mexican Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "2137 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Mexican fare, including a range of cocktails, as well as friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-ad38-7757-962f-059b91484061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-ad38-7757-962f-059b91484061",
        "storage_key": "property/6767906449167603/01a01014-ad38-7757-962f-059b91484061.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://emilianosks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4726499609965223894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emilianos-mexican-cuisine",
      "poi_latitude": "38.8543261",
      "poi_longitude": "-94.7805251",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-839-8510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YhDAQC_wIcR1t__alrml0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ad344a60-6583-4f20-84cd-a3ca16c41554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Casa Amigos",
      "poi_type": "Restaurants",
      "poi_address": "16521 W 159th Terrace, Olathe, KS 66062, USA",
      "poi_short_description": "Casual, family-owned eatery offering familiar Mexican dishes such as burritos, fajitas and enchiladas, plus cocktails, beers and tequila.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-a82f-72f3-9d9c-9cb4469a03f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-a82f-72f3-9d9c-9cb4469a03f0",
        "storage_key": "property/6767906449167603/01a01014-a82f-72f3-9d9c-9cb4469a03f0.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.casaamigoskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12853804186311196342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-amigos",
      "poi_latitude": "38.83905",
      "poi_longitude": "-94.7778556",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-397-0633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TZzwfq-wIcRtv6BGc7iYbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3f4c58c1-06a3-4661-b051-56650646ecd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Third Street Social - Olathe",
      "poi_type": "Restaurants",
      "poi_address": "135 S Kansas Ave, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-ad38-7757-962f-01538d40f9db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-ad38-7757-962f-01538d40f9db",
        "storage_key": "property/6767906449167603/01a01014-ad38-7757-962f-01538d40f9db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thirdstreetsocial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13451170392162562388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "third-street-social---olathe",
      "poi_latitude": "38.8808807",
      "poi_longitude": "-94.8209781",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-490-3730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJScHoCgC9wIcRVPEZTjQorLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_d9166483-a8ca-4881-ba42-cbe2d0903d67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Pizza Shoppe",
      "poi_type": "Restaurants",
      "poi_address": "12750 South Pflumm Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Casual regional chain known for its creative pizzas with cracker crusts, plus sandwiches & pastas.",
      "poi_long_description": "Casual regional chain known for its creative pizzas with cracker crusts, plus sandwiches & pastas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-d4a8-71ce-aa1c-c46595750e61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-d4a8-71ce-aa1c-c46595750e61",
        "storage_key": "property/6767906449167603/01a01014-d4a8-71ce-aa1c-c46595750e61.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pizzashoppepflumm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16702389570820783627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-shoppe",
      "poi_latitude": "38.897441",
      "poi_longitude": "-94.743489",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-397-7117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4WBCFyVwIcRCz72VNLOyuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_1d3e74b6-0623-4339-b3eb-3233e2246d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 N Millridge St, Olathe, KS 66061, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-af9d-779b-9b45-99b4ddadb351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-af9d-779b-9b45-99b4ddadb351",
        "storage_key": "property/6767906449167603/01a01014-af9d-779b-9b45-99b4ddadb351.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/olathe/600-n-millridge-street/f260",
      "poi_directions_map_url": "https://maps.google.com/?cid=10259943237161112872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.88958239999999",
      "poi_longitude": "-94.8360274",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036c-710b-995b-76e94fd8c997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036c-710b-995b-76e94fd8c997",
        "storage_key": "property/6767906449167603/019fc97e-036c-710b-995b-76e94fd8c997.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUJly62XwIcRKNWowgOkYo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_92af5d08-d51a-429f-b1ec-0a2b67c4d4fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "545 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-9779-71a8-9112-cf7c51e639e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-9779-71a8-9112-cf7c51e639e9",
        "storage_key": "property/6767906449167603/019fc981-9779-71a8-9112-cf7c51e639e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-545+e+santa+fe+st-olathe-ks-66061/id=4183",
      "poi_directions_map_url": "https://maps.google.com/?cid=2923151670424089985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8831284",
      "poi_longitude": "-94.8086587",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-393-2757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1UwLwe-wIcRgbU37PQekSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_2420a4d9-f9cf-4cd2-8347-cb66f74c9357",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Conoco",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b327-71ee-a121-e1ab3e16ef9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b327-71ee-a121-e1ab3e16ef9c",
        "storage_key": "property/6767906449167603/01a01014-b327-71ee-a121-e1ab3e16ef9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.conoco.com/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14216070260713086700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conoco",
      "poi_latitude": "38.8931907",
      "poi_longitude": "-94.7967821",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-782-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fd7-758d-ab81-dd4f0ed10ee7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fd7-758d-ab81-dd4f0ed10ee7",
        "storage_key": "property/6767906449167603/019ff6b3-2fd7-758d-ab81-dd4f0ed10ee7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8b36PaVwIcR7F7MB5WgScU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_5b8d0ab2-516f-4a34-a351-09a192e4a96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Phillips 66",
      "poi_type": "Transportation & Transit",
      "poi_address": "15310 KS-7, Olathe, KS 66062, USA",
      "poi_short_description": "Gas station chain outpost offering fuel, hot and cold drinks, and snacks, plus a car wash.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b064-70fb-b438-366ce2995829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b064-70fb-b438-366ce2995829",
        "storage_key": "property/6767906449167603/01a01014-b064-70fb-b438-366ce2995829.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phillips66fuels.com/stations/ks/olathe/phillips-66-fuel-expresso-23-0014x000011uyyt/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5640022371583994355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "38.8501831",
      "poi_longitude": "-94.8164914",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-747-9169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fd7-758d-ab81-dd4f0ed10ee7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fd7-758d-ab81-dd4f0ed10ee7",
        "storage_key": "property/6767906449167603/019ff6b3-2fd7-758d-ab81-dd4f0ed10ee7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2zHi9O9wIcR8ymF_3ZiRU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_b48acb17-7a94-43b5-a471-7359b1c54d21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "395 N K 7 Hwy, Olathe, KS 66061, USA",
      "poi_short_description": "Department store stocking groceries, electronics, home furniture, and clothing, plus garden supplies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b2-db90-718d-8dc5-e472fb75d6aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-db90-718d-8dc5-e472fb75d6aa",
        "storage_key": "property/6767906449167603/019ff6b2-db90-718d-8dc5-e472fb75d6aa.webp",
        "width": 1280,
        "height": 563
      },
      "poi_business_url": "https://www.walmart.com/store/4475-olathe-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14308452471923205416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8861998",
      "poi_longitude": "-94.8377851",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-764-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-030a-734d-af96-8b4ae49cd220",
        "storage_key": "property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2TwGZP2WwIcRKOWKurbVkcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d54d20b6-0b96-4fe3-9594-4f661a07b9da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "15345 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-c640-75e8-beb0-db4c5aee9ec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-c640-75e8-beb0-db4c5aee9ec5",
        "storage_key": "property/6767906449167603/019fc981-c640-75e8-beb0-db4c5aee9ec5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/olathe/1756",
      "poi_directions_map_url": "https://maps.google.com/?cid=15254225791980064040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9099463",
      "poi_longitude": "-94.7643047",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-393-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-030a-734d-af96-8b4ae49cd220",
        "storage_key": "property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz82Qo3SVwIcRKM2SlonlsdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f3f5b8b4-1fda-4f60-942f-366517082381",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "18101 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "Neighborhood grocery store chain with prepared foods, a deli, and a pharmacy, plus online ordering and pickup.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc980-ec5e-7378-aae8-6b77e2ac54e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-ec5e-7378-aae8-6b77e2ac54e1",
        "storage_key": "property/6767906449167603/019fc980-ec5e-7378-aae8-6b77e2ac54e1.webp",
        "width": 1086,
        "height": 764
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=501&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12797416529656855856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.9110474",
      "poi_longitude": "-94.7951339",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-393-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036c-710b-995b-76e94fd8c997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036c-710b-995b-76e94fd8c997",
        "storage_key": "property/6767906449167603/019fc97e-036c-710b-995b-76e94fd8c997.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxAxH8KVwIcRML3otIeOmbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_eb273c85-30b0-4386-b6e2-a258498ec570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Natural Grocers",
      "poi_type": "Shopping & Retail",
      "poi_address": "14921 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_long_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b3f3-75eb-9a8d-f7caefd2e946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b3f3-75eb-9a8d-f7caefd2e946",
        "storage_key": "property/6767906449167603/01a01014-b3f3-75eb-9a8d-f7caefd2e946.webp",
        "width": 1038,
        "height": 1280
      },
      "poi_business_url": "https://www.naturalgrocers.com/store/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820234761812844012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natural-grocers",
      "poi_latitude": "38.9114629",
      "poi_longitude": "-94.7586042",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-764-0918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036c-710b-995b-76e94fd8c997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036c-710b-995b-76e94fd8c997",
        "storage_key": "property/6767906449167603/019fc97e-036c-710b-995b-76e94fd8c997.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJecrGuBKVwIcR7B3MbHx7SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f072839a-8927-4184-991c-79431143555c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "12051 Bass Pro Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b346-740d-845e-854b74f9f453.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b346-740d-845e-854b74f9f453",
        "storage_key": "property/6767906449167603/01a01014-b346-740d-845e-854b74f9f453.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.basspro.com/us/ks/olathe/12051-bass-pro-dr.html?y_source=1_MzAxMTUzMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12711594026814670412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "38.9095905",
      "poi_longitude": "-94.7774654",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-254-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-030a-734d-af96-8b4ae49cd220",
        "storage_key": "property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi3EcXZiVwIcRTAZEIWunaLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_e2cd24b9-0828-4314-917e-916c6b3eaea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "14645 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b4ac-714b-a31e-75bae119d647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b4ac-714b-a31e-75bae119d647",
        "storage_key": "property/6767906449167603/01a01014-b4ac-714b-a31e-75bae119d647.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homegoods.com/store-details/Olathe-KS-66062/0374",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996577034998707075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "38.9097541",
      "poi_longitude": "-94.7570247",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-764-6336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-030a-734d-af96-8b4ae49cd220",
        "storage_key": "property/6767906449167603/019fc97e-030a-734d-af96-8b4ae49cd220.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAQAAD22VwIcRg_PMKTxEtRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d26b9892-8240-4cca-95c7-34d1e8052895",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Ridgeview Elementary School",
      "poi_type": "Education",
      "poi_address": "1201 E Elm St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/ridgeview/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11019603527024972127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridgeview-elementary-school",
      "poi_latitude": "38.8773029",
      "poi_longitude": "-94.7988263",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-7630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2fT2RRC-wIcRXxH3AQZ_7Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8baf1760-5a49-4a5b-9934-88dd8272daf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "La Petite Academy on N. Ridgeview",
      "poi_type": "Education",
      "poi_address": "1825 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-b84b-7482-9033-5d96d4712912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-b84b-7482-9033-5d96d4712912",
        "storage_key": "property/6767906449167603/019fc981-b84b-7482-9033-5d96d4712912.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/olathe-ks-7047/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7047",
      "poi_directions_map_url": "https://maps.google.com/?cid=16469151631103679918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-n-ridgeview",
      "poi_latitude": "38.9104422",
      "poi_longitude": "-94.797912",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4aOEfcKVwIcRrt36syYujuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_70e771f1-91b6-4988-85ed-0f5852f5c974",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "KidZone Learning Center",
      "poi_type": "Education",
      "poi_address": "15320 S Ridgeview Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b2-e59e-748e-91e3-62434a2771d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-e59e-748e-91e3-62434a2771d4",
        "storage_key": "property/6767906449167603/019ff6b2-e59e-748e-91e3-62434a2771d4.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "https://www.kidzonekc.org/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573768024675260545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidzone-learning-center",
      "poi_latitude": "38.8504931",
      "poi_longitude": "-94.7980613",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-780-6365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo9YFA2O-wIcRgRgbTYEjIdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a7d88444-2cf6-447e-9053-ac4d7fd57866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Grace United Methodist Church",
      "poi_type": "Education",
      "poi_address": "11485 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b6a2-7659-a29a-aaf13e830cb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b6a2-7659-a29a-aaf13e830cb4",
        "storage_key": "property/6767906449167603/01a01014-b6a2-7659-a29a-aaf13e830cb4.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "http://graceumc.church/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7808789126129001048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grace-united-methodist-church",
      "poi_latitude": "38.9204101",
      "poi_longitude": "-94.7964571",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-859-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-e2e8-7149-88d8-98fd0dbd5b10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01014-e2e8-7149-88d8-98fd0dbd5b10",
        "storage_key": "property/6767906449167603/01a01014-e2e8-7149-88d8-98fd0dbd5b10.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0EyVM-VwIcRWCLaZFZkXmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_0178de9f-3e04-4995-89f8-b5d0b14215e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe Christian Church",
      "poi_type": "Education",
      "poi_address": "1115 S Ridgeview Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-ba3e-77be-be85-55a3a67d0cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-ba3e-77be-be85-55a3a67d0cb7",
        "storage_key": "property/6767906449167603/01a01014-ba3e-77be-be85-55a3a67d0cb7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.olathecc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=84587665940905559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-christian-church",
      "poi_latitude": "38.8659891",
      "poi_longitude": "-94.7984753",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-782-3041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-e2e8-7149-88d8-98fd0dbd5b10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01014-e2e8-7149-88d8-98fd0dbd5b10",
        "storage_key": "property/6767906449167603/01a01014-e2e8-7149-88d8-98fd0dbd5b10.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTxVdm2-wIcRV37JtAiELAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_fa1b4127-25a1-480b-9558-fd5ff1882970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Prince of Peace Early Educ Center",
      "poi_type": "Education",
      "poi_address": "16000 W 143rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7724027314524043218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prince-of-peace-early-educ-center",
      "poi_latitude": "38.8695147",
      "poi_longitude": "-94.7717546",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-829-2728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_wh_cTW-wIcR0reePetBMWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_dbe5d364-b931-450b-bda5-a7eb3a0765b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe North High School",
      "poi_type": "Education",
      "poi_address": "600 E Prairie St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-8b40-7676-8354-071ab41b8e09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-8b40-7676-8354-071ab41b8e09",
        "storage_key": "property/6767906449167603/019fc981-8b40-7676-8354-071ab41b8e09.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.olatheschools.org/north",
      "poi_directions_map_url": "https://maps.google.com/?cid=8419070380599350193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-north-high-school",
      "poi_latitude": "38.8875164",
      "poi_longitude": "-94.8082785",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ07SCZ_-VwIcRsROjrueL1nQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_96159687-588f-4993-8a37-e76f40393a59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe West High School",
      "poi_type": "Education",
      "poi_address": "2200 W Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-b890-721c-b79b-dba87820e016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-b890-721c-b79b-dba87820e016",
        "storage_key": "property/6767906449167603/01a01014-b890-721c-b79b-dba87820e016.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olatheschools.org/west",
      "poi_directions_map_url": "https://maps.google.com/?cid=1479678690496323995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-west-high-school",
      "poi_latitude": "38.8850301",
      "poi_longitude": "-94.854845",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-780-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-WFKsH-9wIcRm6G_6O3fiBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7db659ab-e87b-4b27-b6f3-6148ec040d81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Kansas State University",
      "poi_type": "Education",
      "poi_address": "22201 W Innovation Dr, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-cfbc-747a-b428-cc7f6b2a66de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-cfbc-747a-b428-cc7f6b2a66de",
        "storage_key": "property/6767906449167603/019fc981-cfbc-747a-b428-cc7f6b2a66de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://olathe.k-state.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16032262921517298555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-state-university",
      "poi_latitude": "38.9285466",
      "poi_longitude": "-94.8425006",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-541-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq6qqquqXwIcRe3O0Pi8Kft4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4e5b729e-4191-4922-b397-979c7f9b22d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Johnson County Community College: Olathe Health Education Center",
      "poi_type": "Education",
      "poi_address": "21201 W 152nd St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-be8b-779d-974b-a763e8d98e20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-be8b-779d-974b-a763e8d98e20",
        "storage_key": "property/6767906449167603/01a01014-be8b-779d-974b-a763e8d98e20.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "https://www.jccc.edu/about/campus/maps/off-campus/ohec.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2051377352076894764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college-olathe-health-education-center",
      "poi_latitude": "38.85235",
      "poi_longitude": "-94.83084",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXeUftMm9wIcRLCLTQtX0dxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_0c1cc065-74b6-4708-be2a-b4cb05bd4849",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Main Event Olathe",
      "poi_type": "Restaurants",
      "poi_address": "11950 N Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Casual entertainment venue featuring laser tag and a rope course, plus bowling lanes and arcade-style video games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-829b-76be-8284-7816855a9704.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-829b-76be-8284-7816855a9704",
        "storage_key": "property/6767906449167603/019fc97c-829b-76be-8284-7816855a9704.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.mainevent.com/locations/kansas/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14851719059725861874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-olathe",
      "poi_latitude": "38.911748",
      "poi_longitude": "-94.7758366",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-768-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0313-72e3-8f74-8f64d4f3fbc5",
        "storage_key": "property/6767906449167603/019fc97e-0313-72e3-8f74-8f64d4f3fbc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOURoFKKVwIcR8sPbCsznG84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bf452a08-6090-46c1-9b8a-cf97ab696275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "AMC Studio 28",
      "poi_type": "Entertainment",
      "poi_address": "12075 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Movie theater and dine-in eatery offering the latest releases, as well as a bar and snack counter.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-d3f3-701e-a081-3de31db3d15b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-d3f3-701e-a081-3de31db3d15b",
        "storage_key": "property/6767906449167603/019fc981-d3f3-701e-a081-3de31db3d15b.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-studio-28?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16780991066006934845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-studio-28",
      "poi_latitude": "38.907307",
      "poi_longitude": "-94.7671361",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-393-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe6-7408-ade4-162ad8b5881e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe6-7408-ade4-162ad8b5881e",
        "storage_key": "property/6767906449167603/019ff6b3-2fe6-7408-ade4-162ad8b5881e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3tZuHWVwIcRPdVYDHcO4ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2e71f74c-2ead-46fa-bfae-e688a80571ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Mahaffie Stagecoach Stop-Farm",
      "poi_type": "Entertainment",
      "poi_address": "1200 E Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_long_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-89c3-74ba-8d9f-9127b1ad64be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-89c3-74ba-8d9f-9127b1ad64be",
        "storage_key": "property/6767906449167603/019fc97c-89c3-74ba-8d9f-9127b1ad64be.webp",
        "width": 1200,
        "height": 965
      },
      "poi_business_url": "http://www.mahaffie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4906880325698000129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-stagecoach-stop-farm",
      "poi_latitude": "38.8920954",
      "poi_longitude": "-94.7996569",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-971-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0371-701d-9cb1-472b1c2a2498.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0371-701d-9cb1-472b1c2a2498",
        "storage_key": "property/6767906449167603/019fc97e-0371-701d-9cb1-472b1c2a2498.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5f59bfeVwIcRARWVkKi9GEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e6d1a947-e676-47d0-a454-22a1be6a7ff8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Museum of Deaf History, Arts and Culture",
      "poi_type": "Entertainment",
      "poi_address": "455 E Park St, Olathe, KS 66061, USA",
      "poi_short_description": "Museum with exhibits, historical information, events & workshops related to the hearing impaired.",
      "poi_long_description": "Museum with exhibits, historical information, events & workshops related to the hearing impaired.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-be77-73ce-afed-9621572f3306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-be77-73ce-afed-9621572f3306",
        "storage_key": "property/6767906449167603/01a01014-be77-73ce-afed-9621572f3306.webp",
        "width": 723,
        "height": 491
      },
      "poi_business_url": "http://www.museumofdeaf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17703514463863482569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-deaf-history-arts-and-culture",
      "poi_latitude": "38.88174950000001",
      "poi_longitude": "-94.8125358",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-324-5348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0371-701d-9cb1-472b1c2a2498.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0371-701d-9cb1-472b1c2a2498",
        "storage_key": "property/6767906449167603/019fc97e-0371-701d-9cb1-472b1c2a2498.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc18ypf29wIcRyaiSjpuEr_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_dadbfcd4-f9a5-4db1-aca5-e129d5062049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Ernie Miller Park & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "909 North, KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_long_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-d199-71df-8c00-8aec1b0e6d3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-d199-71df-8c00-8aec1b0e6d3e",
        "storage_key": "property/6767906449167603/019fc981-d199-71df-8c00-8aec1b0e6d3e.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://erniemiller.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5769145388029025309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernie-miller-park--nature-center",
      "poi_latitude": "38.8967913",
      "poi_longitude": "-94.8409835",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-826-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt22HnSWWwIcRHZwNByofEFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_62823ae0-1315-4cd4-a96a-985fb6e6f8cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Lake Olathe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 S Lakeshore Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a beach, an obstacle course, a waterfall and cliffs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-1d0d-7248-91e5-9f265719fb89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-1d0d-7248-91e5-9f265719fb89",
        "storage_key": "property/6767906449167603/019fc982-1d0d-7248-91e5-9f265719fb89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/lake-olathe-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6997584864379487297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-olathe-park",
      "poi_latitude": "38.8735242",
      "poi_longitude": "-94.8731186",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-971-8973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZtehEK9wIcRQUT9_ltqHGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0e741bc9-45bb-401c-b05f-d2b0c81d9daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Kansas City Automotive Museum",
      "poi_type": "Entertainment",
      "poi_address": "15095 W 116th St, Olathe, KS 66062, USA",
      "poi_short_description": "Museum dedicated to the local auto industry, with over 30 cars on display & interactive exhibits.",
      "poi_long_description": "Museum dedicated to the local auto industry, with over 30 cars on display & interactive exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-9b4f-7681-a08d-f11a6e5fb8b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-9b4f-7681-a08d-f11a6e5fb8b9",
        "storage_key": "property/6767906449167603/019fc97c-9b4f-7681-a08d-f11a6e5fb8b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kansascityautomuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13669185181759054004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-automotive-museum",
      "poi_latitude": "38.9181489",
      "poi_longitude": "-94.76054",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-322-4227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0371-701d-9cb1-472b1c2a2498.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0371-701d-9cb1-472b1c2a2498",
        "storage_key": "property/6767906449167603/019fc97e-0371-701d-9cb1-472b1c2a2498.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwbVaw6VwIcRtCDIF4Czsr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2f9b86fc-e969-45b9-a14b-68e9284b851f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Chestnut Fine Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "234 N Chestnut St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-c25a-7596-a491-cabbb501015d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-c25a-7596-a491-cabbb501015d",
        "storage_key": "property/6767906449167603/01a01014-c25a-7596-a491-cabbb501015d.webp",
        "width": 1090,
        "height": 646
      },
      "poi_business_url": "http://www.chestnutfinearts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4700565784490169173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chestnut-fine-arts-center",
      "poi_latitude": "38.8848044",
      "poi_longitude": "-94.8179798",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-764-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSpFDPm9wIcRVVPkI63DO0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1f97d130-8b5e-41e2-900e-08c44220675d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe Civic Theatre Association",
      "poi_type": "Entertainment",
      "poi_address": "500 E Loula St, Olathe, KS 66061, USA",
      "poi_short_description": "Theater and event-space venue, staging a variety of musical and comedic productions, from classics to current shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b2-ea06-774f-af51-1b524618e718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-ea06-774f-af51-1b524618e718",
        "storage_key": "property/6767906449167603/019ff6b2-ea06-774f-af51-1b524618e718.webp",
        "width": 604,
        "height": 402
      },
      "poi_business_url": "http://www.olathetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1677147266849540730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-civic-theatre-association",
      "poi_latitude": "38.88076",
      "poi_longitude": "-94.81113",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-782-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9uSeP29wIcReoqVpI1sRhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_680088b3-799f-42d4-82e9-1922b727ba11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Stone Pillar Vineyard & Winery",
      "poi_type": "Restaurants",
      "poi_address": "29080 W 95th St, De Soto, KS 66018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-c4b5-734c-917f-27b76cbf6e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-c4b5-734c-917f-27b76cbf6e88",
        "storage_key": "property/6767906449167603/01a01014-c4b5-734c-917f-27b76cbf6e88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stonepillarvineyard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5435369848283445291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-pillar-vineyard--winery",
      "poi_latitude": "38.9567783",
      "poi_longitude": "-94.9218179",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-839-2185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0-10H2WwIcRK7jNRRRQbks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "winery"
    },
    {
      "id": "custom_a42c5371-deab-4c88-af45-1f61d98e733f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "20333 W 151st St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-adfe-76c9-8c62-7686357c0a37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-adfe-76c9-8c62-7686357c0a37",
        "storage_key": "property/6767906449167603/019fc97c-adfe-76c9-8c62-7686357c0a37.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/olathe-hospital?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16276948923291160757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-hospital",
      "poi_latitude": "38.85260299999999",
      "poi_longitude": "-94.822969",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-445-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0375-76b9-8811-4ecc8bc28401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0375-76b9-8811-4ecc8bc28401",
        "storage_key": "property/6767906449167603/019fc97e-0375-76b9-8811-4ecc8bc28401.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQclTbs69wIcRtVDyh85W4-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_be2cc8cb-36eb-4103-ba94-176f833a7afd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "UpCare Medical Clinics",
      "poi_type": "Health and Wellness",
      "poi_address": "790 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-f2df-77ae-ad97-e76c87955eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-f2df-77ae-ad97-e76c87955eaf",
        "storage_key": "property/6767906449167603/019fc981-f2df-77ae-ad97-e76c87955eaf.webp",
        "width": 786,
        "height": 790
      },
      "poi_business_url": "https://upcaremedicalclinics.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15665715531884415044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upcare-medical-clinics",
      "poi_latitude": "38.8922164",
      "poi_longitude": "-94.7952",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-397-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKRTc3M6VwIcRREhKlkbNZ9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_89862f51-a24d-4013-abf1-91192f24df98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Saint Luke's Convenient Care - Hy-Vee 119th & Ridgeview",
      "poi_type": "Health and Wellness",
      "poi_address": "18101 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-c41a-77ae-be7a-3cf9323f8a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-c41a-77ae-be7a-3cf9323f8a86",
        "storage_key": "property/6767906449167603/01a01014-c41a-77ae-be7a-3cf9323f8a86.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.saintlukeskc.org/locations/saint-lukes-convenient-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=15451200982882322473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-convenient-care---hy-vee-119th--ridgeview",
      "poi_latitude": "38.9110442",
      "poi_longitude": "-94.7951486",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-323-8895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRpIHcKVwIcRKQjeEW6xbdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6496da3f-ef9d-42be-8bb7-d763ea5e48d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "18351 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-0e4e-7789-bd7d-467a3e7f6a17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-0e4e-7789-bd7d-467a3e7f6a17",
        "storage_key": "property/6767906449167603/019fc981-0e4e-7789-bd7d-467a3e7f6a17.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/olathe-ks-pharmacies/18351-w-119th-st-olathe-ks-66061/storeid=5156?WT.mc_id=LS_GOOGLE_RX_5156",
      "poi_directions_map_url": "https://maps.google.com/?cid=17786826485382196679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.9121746",
      "poi_longitude": "-94.797957",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-397-7325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe2-715c-9244-0fb66ced28cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe2-715c-9244-0fb66ced28cc",
        "storage_key": "property/6767906449167603/019ff6b3-2fe2-715c-9244-0fb66ced28cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJReJ58MKVwIcRxy23JnOA1_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_26d6c106-887f-4929-94fa-d3e9d1f10980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "395 KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc981-fb17-7110-bba6-192dee204f69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-fb17-7110-bba6-192dee204f69",
        "storage_key": "property/6767906449167603/019fc981-fb17-7110-bba6-192dee204f69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4475-olathe-ks/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=870151484337720401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "38.886244",
      "poi_longitude": "-94.837983",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-764-7165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe2-715c-9244-0fb66ced28cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe2-715c-9244-0fb66ced28cc",
        "storage_key": "property/6767906449167603/019ff6b3-2fe2-715c-9244-0fb66ced28cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLfsLhY29wIcRUYy6LCpmEww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9276bbe6-8b79-4291-8f7a-8e9f31f5a97e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "545 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-c578-722f-9307-668af1ec8371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-c578-722f-9307-668af1ec8371",
        "storage_key": "property/6767906449167603/01a01014-c578-722f-9307-668af1ec8371.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-545+e+santa+fe+st-olathe-ks-66061/id=4183",
      "poi_directions_map_url": "https://maps.google.com/?cid=10081796543837585021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.8831394",
      "poi_longitude": "-94.8086489",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-393-2757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe2-715c-9244-0fb66ced28cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe2-715c-9244-0fb66ced28cc",
        "storage_key": "property/6767906449167603/019ff6b3-2fe2-715c-9244-0fb66ced28cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfYfMAe-wIcRfT4zfYq86Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a163da00-cf2c-4a15-9ec5-6920aa6276c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Olathe Ridgeview",
      "poi_type": "Health and Wellness",
      "poi_address": "17800 W 106th St, Olathe, KS 66061, USA",
      "poi_short_description": "Indoor, outdoor and lap pools, plus a hot tub and sauna at a clean gym with friendly service and a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-9d42-74ee-9c8d-f70de3214cb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-9d42-74ee-9c8d-f70de3214cb4",
        "storage_key": "property/6767906449167603/019fc97c-9d42-74ee-9c8d-f70de3214cb4.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/olathe-ridgeview.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6125827274303493315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---olathe-ridgeview",
      "poi_latitude": "38.9378575",
      "poi_longitude": "-94.7920782",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-888-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QAhYTaUwIcRw1RCMHNPA1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1c5c82ae-f1ec-4e8c-8187-d4b1dba3d434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "RoKC",
      "poi_type": "Health and Wellness",
      "poi_address": "654 N Central St, Olathe, KS 66061, USA",
      "poi_short_description": "Climbing gym with top-roping, bouldering, lead climbing, autobelays, and yoga classes, as well as a weight room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-134e-7046-a1df-8741df557ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b3-134e-7046-a1df-8741df557ca9",
        "storage_key": "property/6767906449167603/019ff6b3-134e-7046-a1df-8741df557ca9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.climbkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10448020602287777537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rokc",
      "poi_latitude": "38.890725",
      "poi_longitude": "-94.7954392",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-318-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrT3QAmmVwIcRAWdTvWHT_pA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_a77d4a78-9999-4a61-8914-86c43debc92c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "F45 Training Olathe",
      "poi_type": "Health and Wellness",
      "poi_address": "15293 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-c520-745a-8698-1ebd3df02797.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-c520-745a-8698-1ebd3df02797",
        "storage_key": "property/6767906449167603/01a01014-c520-745a-8698-1ebd3df02797.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://f45training.com/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=12935903218661686325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-olathe",
      "poi_latitude": "38.9100954",
      "poi_longitude": "-94.762073",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-600-5840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbI2HMSVwIcRNXwppXCPhbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5149efde-2f60-46a5-acc2-3b96032f77e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "BODYBAR Pilates - Lenexa",
      "poi_type": "Health and Wellness",
      "poi_address": "12825 W 87th St, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-c714-75de-aeca-608ccb2518b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-c714-75de-aeca-608ccb2518b9",
        "storage_key": "property/6767906449167603/01a01014-c714-75de-aeca-608ccb2518b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bodybarpilates.com/studios/kansas/lenexa/?utm_source=gbp_location_id=48853",
      "poi_directions_map_url": "https://maps.google.com/?cid=15551910225480802224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodybar-pilates---lenexa",
      "poi_latitude": "38.9703131",
      "poi_longitude": "-94.7346202",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-302-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz1vbFwCVwIcRsF-M2PN709c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e75ef196-4329-424b-9e88-73af1128ca51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe Two Trails Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Locally popular outdoor spot featuring a baseball field, tennis courts and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-102b-72cf-b344-9d4ce3fd965c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-102b-72cf-b344-9d4ce3fd965c",
        "storage_key": "property/6767906449167603/019fc982-102b-72cf-b344-9d4ce3fd965c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/two-trails-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8981433256265339244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-two-trails-park",
      "poi_latitude": "38.8952567",
      "poi_longitude": "-94.7958439",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3TyQPGVwIcRbFGT_fV1pHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59250623-905b-43e4-b153-80fe202629b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Prairie Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "555 N Olathe View Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Community park covering 86 acres with a fishing pond, trail, soccer & baseball fields & disc golf.",
      "poi_long_description": "Community park covering 86 acres with a fishing pond, trail, soccer & baseball fields & disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-1dde-7159-890a-9dc3002e17d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-1dde-7159-890a-9dc3002e17d7",
        "storage_key": "property/6767906449167603/019fc982-1dde-7159-890a-9dc3002e17d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/parks/prairie-center-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1548584147364877856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-center-park",
      "poi_latitude": "38.8907907",
      "poi_longitude": "-94.8462045",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aiBfCmWwIcRIBZ8yBOtfRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bf2ebaab-131e-49ec-a2a9-9aa0e028c587",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Northwood Trails Access Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11344 S Millview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Park offering trails for biking and walking, in addition to playground equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-cbd6-7532-bc57-588871026e0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-cbd6-7532-bc57-588871026e0b",
        "storage_key": "property/6767906449167603/01a01014-cbd6-7532-bc57-588871026e0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15368602218914909891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwood-trails-access-park",
      "poi_latitude": "38.9230271",
      "poi_longitude": "-94.8031849",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-312-8833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1dIttCVwIcRww60sEo-SNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0def8db7-74db-4400-98a8-37e21f065bf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Black Bob Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14500 W 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_long_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-cb5a-739f-8db6-7743c5558c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-cb5a-739f-8db6-7743c5558c65",
        "storage_key": "property/6767906449167603/019fc97c-cb5a-739f-8db6-7743c5558c65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/black-bob-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317087441858333318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-bob-park",
      "poi_latitude": "38.8583619",
      "poi_longitude": "-94.7539901",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTqNmKS_wIcRhgoMG4_Nqlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_38acd611-65bb-4805-afb8-765cf0a8a495",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Mill Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "320 E Poplar St, Olathe, KS 66061, USA",
      "poi_short_description": "Relaxed park has a playground for kids and picnic tables, along with a public pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-1e8b-7078-9dc9-75dc6741eb71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-1e8b-7078-9dc9-75dc6741eb71",
        "storage_key": "property/6767906449167603/019fc982-1e8b-7078-9dc9-75dc6741eb71.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://olatheks.org/parksrec/mill-creek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11806928506389374773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-park",
      "poi_latitude": "38.8859023",
      "poi_longitude": "-94.8169529",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEaRoIPm9wIcRNafFt-ui2qM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e49943c2-ce5f-438f-8748-b079aefa2fb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Oregon Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 S Robinson Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Well-kept park featuring a playground, sand volleyball courts and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-14e9-72fd-8a8c-fff10d9b3550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b3-14e9-72fd-8a8c-fff10d9b3550",
        "storage_key": "property/6767906449167603/019ff6b3-14e9-72fd-8a8c-fff10d9b3550.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/oregon-trail-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242691328296095887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oregon-trail-park",
      "poi_latitude": "38.8672175",
      "poi_longitude": "-94.844934",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfyY7hZi9wIcRjxAccvzHwUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4849503f-3b15-4c68-b4f0-6b4eea1e6f2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Mahaffie Pond Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-1ea4-704b-a898-fa0fd0d5314b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-1ea4-704b-a898-fa0fd0d5314b",
        "storage_key": "property/6767906449167603/019fc982-1ea4-704b-a898-fa0fd0d5314b.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/parks/mahaffie-pond-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12620911710381889436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-pond-park",
      "poi_latitude": "38.89352909999999",
      "poi_longitude": "-94.8026957",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0376-7039-9c40-8d6423d8496b",
        "storage_key": "property/6767906449167603/019fc97e-0376-7039-9c40-8d6423d8496b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6bEJ-GVwIcRnFfhBlV8Jq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7683b194-60be-4759-8fe6-16397dd1b544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Strang Line Road Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436547488501433531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-line-road-park-and-ride",
      "poi_latitude": "38.9082495",
      "poi_longitude": "-94.774183",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe5-7137-9985-b432a7401183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe5-7137-9985-b432a7401183",
        "storage_key": "property/6767906449167603/019ff6b3-2fe5-7137-9985-b432a7401183.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1GA1J6VwIcRu4TjsbsRsS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_b3d7453e-d19d-4004-af31-d51def5c966d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "On S Strang Line Road at w 119th Plaza Southbound",
      "poi_type": "Transportation & Transit",
      "poi_address": "Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-d144-714c-b292-6bc85eaf7c8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-d144-714c-b292-6bc85eaf7c8d",
        "storage_key": "property/6767906449167603/01a01014-d144-714c-b292-6bc85eaf7c8d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13350404968865868338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-s-strang-line-road-at-w-119th-plaza-southbound",
      "poi_latitude": "38.911058",
      "poi_longitude": "-94.767193",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe5-7137-9985-b432a7401183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe5-7137-9985-b432a7401183",
        "storage_key": "property/6767906449167603/019ff6b3-2fe5-7137-9985-b432a7401183.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-wkLnWVwIcRMirc8JUqRrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_04e1e1b3-81db-4f40-b29d-2a70012fd313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-cda9-731e-8b6c-6561daf7d245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-cda9-731e-8b6c-6561daf7d245",
        "storage_key": "property/6767906449167603/01a01014-cda9-731e-8b6c-6561daf7d245.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_077aceac-2311-4bde-bf4a-f361425c9b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-3006-743c-8440-2e5c88d98842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-3006-743c-8440-2e5c88d98842",
        "storage_key": "property/6767906449167603/019ff6b3-3006-743c-8440-2e5c88d98842.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_a30b4aac-6ec8-4c36-bcbd-e56d6969c4d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "14.4",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-3006-743c-8440-2e5c88d98842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-3006-743c-8440-2e5c88d98842",
        "storage_key": "property/6767906449167603/019ff6b3-3006-743c-8440-2e5c88d98842.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_b43cdb69-a8ec-48f9-a469-dc8e04edb789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Shawnee Station Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Shawnee, KS 66217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6607180038980660494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-station-park-and-ride",
      "poi_latitude": "39.00885",
      "poi_longitude": "-94.764741",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-2fe5-7137-9985-b432a7401183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b3-2fe5-7137-9985-b432a7401183",
        "storage_key": "property/6767906449167603/019ff6b3-2fe5-7137-9985-b432a7401183.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJDR_vmwaTwIcRDm1-Nj1rsVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_9512a9e0-c4b4-4686-91cf-6c5d5d538c3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-2e4f-7039-a7c1-8e8b4b355987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-2e4f-7039-a7c1-8e8b4b355987",
        "storage_key": "property/6767906449167603/019fc982-2e4f-7039-a7c1-8e8b4b355987.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "41.8",
      "poi_walking_minutes": "15 hours 30 mins",
      "poi_biking_minutes": "4 hours 24 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-1042-71fd-ae78-038d7a232a9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-1042-71fd-ae78-038d7a232a9d",
        "storage_key": "property/6767906449167603/019fc97e-1042-71fd-ae78-038d7a232a9d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f2b56d47-7f29-472b-a2df-815b5e5b133e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-be69-732f-8312-718c85c557d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-be69-732f-8312-718c85c557d5",
        "storage_key": "property/6767906449167603/019fc97c-be69-732f-8312-718c85c557d5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e8f40d07-e544-4010-b1b8-383b30810938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Olathe Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14160 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc982-3422-7212-aee1-5023146c0c18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-3422-7212-aee1-5023146c0c18",
        "storage_key": "property/6767906449167603/019fc982-3422-7212-aee1-5023146c0c18.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.olatheschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2471559516784985002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-public-schools",
      "poi_latitude": "38.8710187",
      "poi_longitude": "-94.7620475",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-780-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAyR-Mci_wIcRqoM0H0m-TCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b439a9f-027d-4f59-a607-bf5806940de3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019ff6b3-1f0b-72bd-aa57-e863cd18fcba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b3-1f0b-72bd-aa57-e863cd18fcba",
        "storage_key": "property/6767906449167603/019ff6b3-1f0b-72bd-aa57-e863cd18fcba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-1041-74a2-af21-79170b4a27fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-1041-74a2-af21-79170b4a27fa",
        "storage_key": "property/6767906449167603/019fc97e-1041-74a2-af21-79170b4a27fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_1c9e1434-75a0-4671-bae6-2e6e43e40280",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "City of Olathe City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97d-c749-7039-8306-267f8939a964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-c749-7039-8306-267f8939a964",
        "storage_key": "property/6767906449167603/019fc97d-c749-7039-8306-267f8939a964.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "http://www.olatheks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9492556933527452182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-olathe-city-hall",
      "poi_latitude": "38.883783",
      "poi_longitude": "-94.8192239",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-971-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-1041-74a2-af21-79170b4a27fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-1041-74a2-af21-79170b4a27fa",
        "storage_key": "property/6767906449167603/019fc97e-1041-74a2-af21-79170b4a27fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUibmfm9wIcRFjoTwTxWvIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_b927653f-9f72-46fc-897a-255d53960fbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Amazon Fulfillment MCI7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27200 W 157th St, New Century, KS 66031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-d21e-715e-8ee1-77224267f7f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-d21e-715e-8ee1-77224267f7f3",
        "storage_key": "property/6767906449167603/01a01014-d21e-715e-8ee1-77224267f7f3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://amazon-mci7.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11376756298398505973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fulfillment-mci7",
      "poi_latitude": "38.8448847",
      "poi_longitude": "-94.9014479",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 913-397-0062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTZ-s9eiwIcR9Rs7ppNb4p0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_c3fe0544-8d2c-4856-9feb-3cec7956f44d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "FAA Kansas City Air Route Traffic Control Center (ARTCC ZKC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "250 S Rogers Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.faa.gov/about/office_org/headquarters_offices/ato/service_units/air_traffic_services/artcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14145768989397863200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faa-kansas-city-air-route-traffic-control-center-artcc-zkc",
      "poi_latitude": "38.8800671",
      "poi_longitude": "-94.7905515",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-254-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-1041-74a2-af21-79170b4a27fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-1041-74a2-af21-79170b4a27fa",
        "storage_key": "property/6767906449167603/019fc97e-1041-74a2-af21-79170b4a27fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRLUERi-wIcRIMvLx_LdT8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_276a722f-92bf-4320-99b6-1eb82a3a7b6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97c-86f9-746b-b9b4-752e8cf4b7fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-86f9-746b-b9b4-752e8cf4b7fb",
        "storage_key": "property/6767906449167603/019fc97c-86f9-746b-b9b4-752e8cf4b7fb.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-0319-756f-9bf3-69f923077b36",
        "storage_key": "property/6767906449167603/019fc97e-0319-756f-9bf3-69f923077b36.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_02df76da-e489-448b-9037-a91788a49384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-d1a0-76d9-8aad-5cf7b6d4f462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-d1a0-76d9-8aad-5cf7b6d4f462",
        "storage_key": "property/6767906449167603/01a01014-d1a0-76d9-8aad-5cf7b6d4f462.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_b3a515e3-e9b6-491e-ba4d-b69b00e0c4f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a01014-d326-7185-9c93-03498b4f36c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-d326-7185-9c93-03498b4f36c3",
        "storage_key": "property/6767906449167603/01a01014-d326-7185-9c93-03498b4f36c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065491002476993060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9158914",
      "poi_longitude": "-94.6621181",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97e-036d-77cf-8dc9-78f00fe85e4e",
        "storage_key": "property/6767906449167603/019fc97e-036d-77cf-8dc9-78f00fe85e4e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0P_xjzrwIcRJBrguPIW9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9e0224b1f39e58eb58525d9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_4ee49f81d4a988bfef9dbe72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2a2e990d912473e6823b183e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4d6ab235d0e9384246d550eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c6f484bff45d3811a8803118",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a6522975a7cdbad611a6fe11",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_33f36ee4630dab69f4138df9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "rating": "5",
      "name": "Dusty Shull",
      "text": "I've lived here for 15 years, give or take a year I believe, in a single 1 bedroom apartment. Moved in in my mid 20s from another Price Brothers property and came to enjoy the nice calmness and serine location and friendliness of the neighbors and older adults. Now I'm in my 40s and one of those!\n\nThe scenery is great with a nice clean lake, ducks/geese often around all year. They also have a good Pool, Fitness Center and other amenities. Plus, The property is ALWAYS in top notch shape. Landscaping is handled often and honestly feels like during the Summer days it may be daily they are out there doing yard work, mowing, weeding, ect - to ensure a beautiful property. Same with winter, as de-icing/salting is common and sidewalks/stairs/entryway's are well scooped clear after/during snowfalls.\nThe Maintenance team has always been top notch as well.\n\nI can honestly say I've never really had any issues with any of the staff and should Maintenance be needed, it's prompt and professionally handled that day or next depending on priority and busyness. And any questions/concerns are handled over a phone call or e-mail, or in office visit if needed.\n\nFor the parents, there's also community events often, some of which that can be geared towards kids to give them some enjoyment like Halloween, and others like Pool Parties and various drink social's type things.\n\nI recommend Millcreek Woods to folk all the time, and will continue to do so.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "ec_697e61aaf2c299a35077d626",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "rating": "4",
      "name": "Sara Williams",
      "text": "I lived there for years with my father and my best life experiences were in these apartments. The pool, the basketball court, the creek and meeting my best friend. Living here has changed me for the better, miss it so much, people who live here still are incredibly lucky",
      "date": "2026-02-28",
      "title": "false"
    },
    {
      "id": "ec_ca39872677beee116f763dcb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "rating": "5",
      "name": "Luke Neuburger",
      "text": "My family has lived here for years now, and honestly this is a great apartment community. The maintenance response time is excellent, and you don't find that very often. The fitness center plus the mile trail around the apartments saves money and is convenient. I have multiple businesses acquaintances who also live here who feel the same way. The staff hold multiple events throughout the year with the most recent being a really fun pool party we attended. The staff are all friendly and willing to help. If you want the best value for your money rent here!",
      "date": "2025-07-01",
      "title": "false"
    },
    {
      "id": "ec_6ba0549deaa9fd41b003b522",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "rating": "5",
      "name": "Madjid Bouzid",
      "text": "10/10 service, the team was very helpful with my move in nice and safe , clean and affordable apartments",
      "date": "2026-06-10",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_635e0565c5aafb347ec033b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-35a4-7555-a9e8-c8f52265b738.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102c-35a4-7555-a9e8-c8f52265b738",
        "storage_key": "property/6767906449167603/01a0102c-35a4-7555-a9e8-c8f52265b738.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Santa Fe",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GgpLcG61vie"
    },
    {
      "id": "ec_80d511b1443c411c5a774956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-35f1-73a4-8aa0-c80c6d127b53.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102c-35f1-73a4-8aa0-c80c6d127b53",
        "storage_key": "property/6767906449167603/01a0102c-35f1-73a4-8aa0-c80c6d127b53.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Santa Rosa",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hSSmehWuVqm"
    },
    {
      "id": "ec_7e688d5b6450afe1827f38a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-36d1-7149-94a7-f03ec14dd90b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102c-36d1-7149-94a7-f03ec14dd90b",
        "storage_key": "property/6767906449167603/01a0102c-36d1-7149-94a7-f03ec14dd90b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rio Grande",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZUouVChjSKe"
    },
    {
      "id": "ec_4974b317b507dfa8523352ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-356a-77de-bc7b-7f6a29bee82c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102c-356a-77de-bc7b-7f6a29bee82c",
        "storage_key": "property/6767906449167603/01a0102c-356a-77de-bc7b-7f6a29bee82c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Santa Cruz",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bN3twnUNg52"
    },
    {
      "id": "ec_172e7760efe9edc6d363dec2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102c-3622-7779-8245-80100ac27b81.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102c-3622-7779-8245-80100ac27b81",
        "storage_key": "property/6767906449167603/01a0102c-3622-7779-8245-80100ac27b81.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Casa Grande",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oE611zaWEMN"
    }
  ],
  "faqs": [
    {
      "id": "custom_d442572c-2d7d-4b11-a4e2-993cae6e0320",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_29f3e2a2-9285-454b-a103-6b2320c587e9",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_33af41e2-5578-4570-bf6b-0d02b5ce0d76",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_51324a79-aed0-4f79-905b-03a797bdfa00",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5780375c-4a31-439e-824e-60236e7ce464",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_524c66dd-7779-42f2-802b-17812db26f4a",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_10881aeb-3997-4b07-a5de-f4695cb0c949",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2661e22e-d991-4d11-97b5-1d7a75e856d0",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f0f92460-338f-4024-9005-0ad08bc0cd4a",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7abfa86d-e520-4474-89a2-bea88ae22d67",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, wastewater, trash, electric and gas (gas is in 2 bedroom apartment homes only).",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1d69e773-7d7e-4ef3-aa22-08f3ce7b49f8",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b4261a4b-c0c2-4490-acfd-19cd5fea21ac",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_23e0f5e3-b405-472d-90ac-6251914da1f7",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c930fff5-2ead-42b3-bb3b-1cfdedc23512",
      "question": "Do you offer covered parking?",
      "answer": "No, however we offer open parking at every building.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_0216401a-6f4c-4701-a497-d04142c01185",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_12d31d7a-a5ce-4221-8762-96490fb639e4",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_e9c22142-e4ef-4e72-9193-7b1ff7711171",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3b9d-72e5-ad99-ce485ea390c3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Millcreek Woods Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603"
    },
    {
      "lead_collector_id": "01a0c9ac-3c2e-7643-9a63-699f046edfee",
      "lead_source": "LANDING_PAGE",
      "name": "Millcreek Woods Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "olathe-apartments-with-pool",
      "search_query": "apartments with pool in Olathe KS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Olathe, KS",
      "h2_subtitle": "Discover your new home at Millcreek Woods Apartment Homes, offering scenic views and pool access. Enjoy nature trails and flexible rent options in Olathe, KS.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Millcreek Woods Apartment Homes. Just a stone's throw from a scenic lake and a one-mile trail, our community offers studio, one-, and two-bedroom options. Although we do not feature a traditional pool, you're surrounded by Olathe's rich outdoor offerings, such as our on-site scenic lake, providing a serene lifestyle. Residents benefit from flexible rent payment options and amenities like a dishwasher and maintenance on site.\n\nFurthermore, the vibrant community atmosphere at Millcreek Woods is complemented by our volleyball court and proximity to recreational hotspots in Johnson County. Every day here feels like a getaway with lush green spaces and convenient access to Olathe's best. Explore our floor plans and amenities today to see why our apartment homes are the ideal choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe Apartments with Scenic Pool Access",
      "seo_description": "Explore Millcreek Woods Apartment Homes in Olathe, KS. Enjoy scenic views and nature trails in a connected community. Flexible rent available.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-millcreek",
      "search_query": "fitness center apartments Millcreek Apartments",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments at Millcreek",
      "h2_subtitle": "Elevate your lifestyle at Millcreek Woods. Discover the perfect blend of nature and fitness center access at Millcreek Apartments.",
      "page_copy": "At Millcreek Woods Apartment Homes, we provide a living experience unlike any other. While our primary focus is on offering tranquil environments with a scenic lake and nature trails, we emphasize active living with nearby recreational opportunities. Located in the heart of Johnson County, Millcreek Apartments provide access to local fitness amenities to complement your active lifestyle needs.\n\nOur community offers large studio, one-, and two-bedroom apartment layouts, each designed to provide comfort and convenience. Beyond the fitness amenities nearby, enjoy our on-site facilities such as a scenic lake, volleyball court, and flexible rent payment options. With maintenance available on-site and dishwasher facilities, residents experience a seamless living environment in Olathe. Discover more by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Millcreek Fitness Center Apartments",
      "seo_description": "Explore Millcreek Woods Apartments near fitness centers in Olathe. Relax by the scenic lake and enjoy nearby facilities with flexible renting options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "olathe-apartments-with-nature-trail",
      "search_query": "Olathe KS apartments with nature trail",
      "category": "Amenity",
      "h1_title": "Olathe, KS Apartments with Nature Trail",
      "h2_subtitle": "Discover nature-inspired living at Millcreek Woods Apartment Homes. Enjoy direct access to a scenic one-mile trail in Olathe, KS.",
      "page_copy": "Embrace a unique and serene lifestyle at Millcreek Woods Apartment Homes, where green space meets modern convenience. Nestled in the thriving community of Olathe, KS, our apartment homes offer direct access to a scenic one-mile nature trail. Enjoy studio, one-, and two-bedroom apartments designed to connect you with the beauty of your surroundings.\n\nResidents of Millcreek Apartments benefit not only from beautiful lake views but also from essential amenities such as flexible rent payment options, a dishwasher, and on-site maintenance services. The nearby volleyball court adds a touch of fun to outdoor living. Experience the best that Olathe has to offer with nature trails at your doorstep and a community designed for relaxation and active living. Schedule a visit to see the natural beauty and comfortable lifestyle awaiting you at Millcreek Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe Nature Trail Apartments",
      "seo_description": "Discover Millcreek Woods in Olathe, KS. Enjoy apartments with direct access to a nature trail, scenic views, and modern amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-johnson-county",
      "search_query": "pet friendly apartments near Johnson County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments near Johnson County",
      "h2_subtitle": "Welcome to Millcreek Woods, where pet-friendly living meets convenience near Johnson County. Enjoy nature and comfort with your furry companion.",
      "page_copy": "Millcreek Woods Apartment Homes offers a perfect haven for pet lovers seeking residences near Johnson County. Nestled in the heart of Olathe, KS, our community caters to both you and your furry friends, offering ample green spaces and a nature trail that beckons exploration. Our spacious studio, one-, and two-bedroom apartments provide the ideal setting for you and your pets.\n\nEmphasizing both comfort and practicality, Millcreek Woods delivers exceptional amenities including on-site maintenance, a dishwasher, and flexible rent payment options. Additionally, our scenic lake and volleyball court offer further opportunities for leisure and relaxation. Discover the blend of comfort and convenience we offer by coming home to Millcreek Woods Apartment Homes — where pets are part of the family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Johnson County",
      "seo_description": "Find pet-friendly living at Millcreek Woods near Johnson County. Enjoy nature trails, modern amenities, and a welcoming environment for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "luxury-apartments-scenic-lake-olathe",
      "search_query": "luxury apartments with scenic lake Olathe",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Scenic Lake in Olathe",
      "h2_subtitle": "Experience premier living at Millcreek Woods. Our luxury apartments provide scenic lake views in Olathe, KS, blending elegance with nature.",
      "page_copy": "Millcreek Woods Apartment Homes invites you to a luxurious lifestyle set against the backdrop of a scenic lake in Olathe, KS. Our apartment community offers studio, one-, and two-bedroom floor plans, expertly designed to complement the natural beauty surrounding you. Enjoy the tranquility and elegance of lakeside living while benefiting from a range of modern conveniences.\n\nIn our carefully crafted apartments, find amenities like a dishwasher and on-site maintenance that add to your ease of living. Beyond the apartment doors, relax by the scenic lake or enjoy peaceful strolls along the one-mile nature trail. Positioned near all that Johnson County offers, Millcreek Woods blends luxury with prime location. Visit us to experience high-end living that resonates with nature’s serenity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Scenic Lake Apartments Olathe",
      "seo_description": "Discover luxury living at Millcreek Woods with scenic lakeside views in Olathe, KS. Enjoy exceptional amenities in a beautiful natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "studio-apartments-olathe-ks",
      "search_query": "studio apartments Olathe KS",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Olathe, KS",
      "h2_subtitle": "Explore stylish studio apartments at Millcreek Woods in Olathe, KS. Enjoy comfort and convenience by the scenic lake.",
      "page_copy": "Find the perfect blend of comfort and style in the studio apartments at Millcreek Woods Apartment Homes, located in vibrant Olathe, KS. Designed with efficiency and elegance in mind, our studios offer practical living spaces complemented by beautiful surroundings, including a nearby scenic lake and nature trail.\n\nResidents of our community enjoy premier amenities such as flexible rent payment options, a dishwasher, and maintenance on site, ensuring a hassle-free lifestyle. Situated in a prime location, you’ll find yourself surrounded by green spaces with the convenience of Johnson County nearby. Visit Millcreek Woods today and discover how our studio apartments can offer the ideal home in Olathe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Olathe, KS",
      "seo_description": "Discover stylish studio apartments at Millcreek Woods, Olathe, KS, offering scenic views and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-johnson-county",
      "search_query": "one bedroom apartments Johnson County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Johnson County",
      "h2_subtitle": "Discover one-bedroom apartments at Millcreek Woods, nestled in scenic Johnson County. Enjoy modern living with excellent amenities.",
      "page_copy": "Millcreek Woods Apartment Homes offers ideal one-bedroom apartments located in the heart of Johnson County. Designed with both style and comfort in mind, our one-bedroom layouts are perfect for individuals or couples seeking a serene living environment beside a picturesque lake and nature trail. Experience a higher standard of living where nature meets modern convenience.\n\nOur community provides a range of amenities, including maintenance on site, a dishwasher, and flexible rent payment options, ensuring a comfortable and stress-free living experience. Enjoy the convenience of our prime location in Olathe, KS, with easy access to local attractions and scenic surroundings. Visit Millcreek Woods today and see our inviting one-bedroom apartments for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Johnson County",
      "seo_description": "Explore one-bedroom apartments at Millcreek Woods in Johnson County. Enjoy serene living with top-notch amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-millcreek-apartments",
      "search_query": "two bedroom apartments near Millcreek Apartments",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Millcreek",
      "h2_subtitle": "Discover spacious two-bedroom apartments near Millcreek Apartments in Olathe. Enjoy comfort and convenience in a scenic location.",
      "page_copy": "At Millcreek Woods Apartment Homes, find spacious two-bedroom apartments nestled near the picturesque Millcreek Apartments. These thoughtfully designed residences offer a perfect blend of modern amenities and serene natural surroundings. Experience an enhanced lifestyle with ample living space set beside a scenic lake and vibrant nature trail.\n\nOur community amenities include convenient options like flexible rent payments and on-site maintenance, ensuring an easy living experience. With a dishwasher in each unit and proximity to scenic outdoor spaces, residents can enjoy both interior comfort and outdoor leisure. Situated in Olathe, KS, our apartments offer the perfect location for those seeking tranquility without sacrificing access to local conveniences. Schedule a visit to Millcreek Woods today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Millcreek",
      "seo_description": "Explore two-bedroom apartments near Millcreek in Olathe for a spacious and serene lifestyle. Visit Millcreek Woods today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "apartments-near-ridgeview-elementary-school",
      "search_query": "apartments near ridgeview elementary school olathe ks",
      "category": "School",
      "h1_title": "Apartments Near Ridgeview Elementary School",
      "h2_subtitle": "Find convenient living at Millcreek Woods, close to Ridgeview Elementary School in Olathe, KS. Perfect for families and professionals alike.",
      "page_copy": "Millcreek Woods Apartment Homes offers exceptional living options just a short distance from Ridgeview Elementary School in Olathe, KS. Our community provides a variety of floor plans, including studio, one-, and two-bedroom apartments, designed to meet diverse lifestyle needs. With a scenic lake and access to a one-mile nature trail, our location offers a beautiful setting alongside practical convenience.\n\nIdeal for families and individuals seeking a home in a nurturing community, Millcreek Woods boasts amenities like flexible rent payment options, a dishwasher in every apartment, and reliable on-site maintenance. Being near Ridgeview Elementary School ensures easy school commutes, making it an ideal choice for families. Discover the balance of nature and convenience at Millcreek Woods Apartment Homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ridgeview Elementary School",
      "seo_description": "Discover apartments near Ridgeview Elementary School in Olathe, KS. Ideal for families seeking convenience and comfort at Millcreek Woods.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "rentals-near-olathe-north-high-school",
      "search_query": "rentals close to olathe north high school johnson county",
      "category": "School",
      "h1_title": "Rentals Close to Olathe North High School",
      "h2_subtitle": "Discover rentals near Olathe North High School in Johnson County. Millcreek Woods offers convenient and comfortable living options.",
      "page_copy": "Millcreek Woods Apartment Homes is perfect for those seeking rentals close to Olathe North High School in Johnson County. Our community provides a selection of studio, one-, and two-bedroom apartment homes designed for convenience and comfort. Surrounded by beautiful green spaces, including a scenic lake and nature trail, our location offers a peaceful retreat from the hustle of daily life.\n\nWith practical amenities such as flexible rent payment options and maintenance on site, living at Millcreek Woods is both convenient and serene. The convenience of living near Olathe North High School allows for easy school commutes and access to local community events. Experience the perfect combination of location and lifestyle at Millcreek Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Olathe North High School",
      "seo_description": "Explore rentals near Olathe North High School in Johnson County. Find comfort and convenience at Millcreek Woods Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "housing-near-olathe-west-high-school",
      "search_query": "housing near olathe west high school",
      "category": "School",
      "h1_title": "Housing Near Olathe West High School",
      "h2_subtitle": "Explore quality housing near Olathe West High School at Millcreek Woods. Enjoy convenient living with access to top schools and local amenities.",
      "page_copy": "Discover ideal housing near Olathe West High School at Millcreek Woods Apartment Homes. Our community offers a variety of floor plans, including studio, one-, and two-bedroom apartments, to cater to diverse living needs. Nestled amid lush landscapes, with a tranquil lake and access to a one-mile nature trail, our community perfectly blends natural beauty with modern convenience.\n\nMillcreek Woods is ideal for families and individuals who prioritize proximity to top educational institutions like Olathe West High School. Enjoy amenities such as flexible rent payment options and on-site maintenance, ensuring a hassle-free living experience. Embrace the convenience and comfort of life in this sought-after neighborhood in Olathe, KS, today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Olathe West High School",
      "seo_description": "Find housing near Olathe West High School at Millcreek Woods. Experience convenient and comfortable living close to education and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-state-university-olathe",
      "search_query": "apartments near kansas state university olathe",
      "category": "School",
      "h1_title": "Apartments Near Kansas State University Olathe",
      "h2_subtitle": "Discover apartments near Kansas State University in Olathe. Millcreek Woods offers a perfect balance of comfort and accessibility.",
      "page_copy": "Millcreek Woods Apartment Homes is an excellent choice for those looking for apartments near Kansas State University in Olathe. Offering a range of studio, one-, and two-bedroom layouts, our community caters to diverse lifestyle preferences, making it ideal for students, faculty, and staff seeking proximity to campus.\n\nSituated amid picturesque surroundings, including a scenic lake and a nature trail, Millcreek Woods offers both tranquility and convenience. Residents enjoy amenities such as flexible rent payment options and on-site maintenance, ensuring a seamless living experience. With its prime location near the university, Millcreek Woods combines the benefits of academic life with comfortable living in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas State University Olathe",
      "seo_description": "Find convenient apartments near Kansas State University in Olathe. Experience comfort and proximity at Millcreek Woods Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "rentals-near-jccc-66061",
      "search_query": "rentals close to johnson county community college 66061",
      "category": "School",
      "h1_title": "Rentals Close to Johnson County Community College",
      "h2_subtitle": "Explore rentals close to Johnson County Community College in the 66061 area. Millcreek Woods offers convenient living near campus.",
      "page_copy": "Millcreek Woods Apartment Homes offers perfect rentals close to Johnson County Community College in the 66061 area. These well-designed studio, one-, and two-bedroom apartments cater to students and professionals seeking proximity to campus while enjoying the beautiful surroundings of Olathe, KS.\n\nThe community features amenities such as flexible rent payment options and on-site maintenance, ensuring a hassle-free living experience. Enjoy leisurely walks along the scenic lake and nature trail right outside your doorstep. Millcreek Woods combines optimal location with comfortable living, making it an ideal choice for those connected with Johnson County Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Johnson County Community College",
      "seo_description": "Discover convenient rentals near Johnson County Community College in 66061. Enjoy ease and comfort at Millcreek Woods Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "apartments-near-lake-olathe-park",
      "search_query": "apartments near Lake Olathe Park Olathe",
      "category": "Park",
      "h1_title": "Apartments Near Lake Olathe Park",
      "h2_subtitle": "Find apartments near Lake Olathe Park. Millcreek Woods offers lakeside living with easy access to outdoor activities.",
      "page_copy": "Discover lakeside living at Millcreek Woods Apartment Homes, located near Lake Olathe Park. Our studio, one-, and two-bedroom apartments provide an ideal setting for those who love outdoor activities and serene views. Enjoy immediate access to the park's amenities and scenic beauty while residing in our welcoming community.\n\nMillcreek Woods enhances your lifestyle with features such as a scenic lake, volleyball court, and nature trail, suitable for both relaxation and fitness. Additionally, flexible rent payment options and on-site maintenance services make living here convenient and stress-free. Experience the perfect blend of nature and comfort at Millcreek Woods in Olathe, KS, near Lake Olathe Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Olathe Park",
      "seo_description": "Explore apartments near Lake Olathe Park. Millcreek Woods offers beautiful living spaces with access to outdoor adventures and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "two-trails-park-nearby-apartments",
      "search_query": "Olathe Two Trails Park nearby apartments",
      "category": "Park",
      "h1_title": "Olathe Two Trails Park Nearby Apartments",
      "h2_subtitle": "Explore nearby apartments to Olathe's Two Trails Park. Millcreek Woods offers a blend of comfort and accessibility.",
      "page_copy": "For those seeking an active lifestyle with easy access to nature, Millcreek Woods Apartment Homes is the perfect choice, located close to Two Trails Park in Olathe. Our community offers a variety of floor plans including studio, one-, and two-bedroom layouts, suited for diverse living preferences.\n\nResidents of Millcreek Woods enjoy the benefit of a scenic lake and nature trail right on their doorstep, along with key amenities like on-site maintenance and flexible rent options. Perfectly positioned near Two Trails Park, you can enjoy daily park visits while experiencing all the comforts of home at Millcreek Woods in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe Two Trails Park Nearby Apartments",
      "seo_description": "Find comfortable apartments near Olathe's Two Trails Park. Enjoy nature and convenience at Millcreek Woods Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "prairie-center-park-near-millcreek",
      "search_query": "Prairie Center Park close by Millcreek Apartments",
      "category": "Park",
      "h1_title": "Prairie Center Park Near Millcreek Apartments",
      "h2_subtitle": "Discover living near Prairie Center Park. Millcreek Apartments offer serene living with park access.",
      "page_copy": "Situated near Prairie Center Park, Millcreek Woods Apartment Homes offer a perfect blend of nature and modern living. With studio, one-, and two-bedroom options, our community is ideal for those who cherish the convenience of nearby outdoor recreation.\n\nThe apartments feature a range of amenities, including a scenic lake and a mile-long nature trail, making it easy to enjoy nature right at home. Flexible rent payment plans and on-site maintenance ensure a hassle-free lifestyle. Experience the picturesque surroundings and the vibrant outdoor life at Millcreek Apartments, perfectly located near Prairie Center Park in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Center Park Near Millcreek Apartments",
      "seo_description": "Live close by Prairie Center Park at Millcreek Apartments. Enjoy lush green spaces and modern conveniences in Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "northwood-trails-access-apartments",
      "search_query": "Northwood Trails Access Park local apartments",
      "category": "Park",
      "h1_title": "Northwood Trails Access Park Local Apartments",
      "h2_subtitle": "Explore local apartments near Northwood Trails Access Park. Experience nature-inspired living at Millcreek Woods.",
      "page_copy": "Millcreek Woods Apartment Homes provide a serene living environment with easy access to Northwood Trails Access Park. Our studio, one-, and two-bedroom apartments are designed to meet the needs of those who appreciate both comfort and the great outdoors.\n\nResidents can enjoy the tranquility of a nearby scenic lake and a nature trail, along with a host of amenities including a volleyball court and on-site maintenance services. With flexible rent payment options, living at Millcreek Woods is both convenient and affordable. Embrace the perfect mix of nature and modern conveniences at our community near Northwood Trails Access Park in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Northwood Trails Access Park Local Apartments",
      "seo_description": "Find local apartments near Northwood Trails Access Park. Millcreek Woods offers a nature-inspired lifestyle in Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "black-bob-park-nearby-apartments",
      "search_query": "Black Bob Park nearby Johnson County apartments",
      "category": "Park",
      "h1_title": "Black Bob Park Nearby Johnson County Apartments",
      "h2_subtitle": "Find nearby apartments to Black Bob Park. Millcreek Woods offers an ideal blend of recreation and modern living.",
      "page_copy": "Nestled near Black Bob Park in Johnson County, Millcreek Woods Apartment Homes provide an exceptional living experience with access to outdoor activities and urban conveniences. Choose from our studio, one-, and two-bedroom apartments designed for comfortable living.\n\nOur community features amenities such as a scenic lake and a nature trail that enhance the outdoor experience even further. With flexible rent payment options and on-site maintenance, residents enjoy a stress-free lifestyle. The proximity to Black Bob Park makes it easy to partake in sports and recreational activities while enjoying the serene environment at Millcreek Woods, located in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Black Bob Park Nearby Johnson County Apartments",
      "seo_description": "Live near Black Bob Park in Johnson County. Experience the perfect mix of recreation and convenience at Millcreek Woods Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "mill-creek-park-near-olathe-apartments",
      "search_query": "Mill Creek Park close by Olathe KS apartments",
      "category": "Park",
      "h1_title": "Mill Creek Park Close by Olathe KS Apartments",
      "h2_subtitle": "Discover apartments close to Mill Creek Park. Millcreek Woods offers a balance of nature and comfort in Olathe.",
      "page_copy": "Experience the charm of living close to Mill Creek Park with Millcreek Woods Apartment Homes, situated in Olathe, KS. Our studio, one-, and two-bedroom apartments are perfect for those seeking an active lifestyle entwined with the serenity of nature.\n\nResidents at Millcreek Woods enjoy amenities like a stunning scenic lake and a nature trail, perfect for tranquil walks and relaxation. Flexible rent payment options and prompt maintenance services enhance the overall living experience. Embrace the convenience of being near Mill Creek Park, where recreation and relaxation go hand-in-hand at Millcreek Woods Apartments in Olathe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mill Creek Park Close by Olathe KS Apartments",
      "seo_description": "Find apartments near Mill Creek Park in Olathe. Millcreek Woods offers scenic living with access to outdoor and urban amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "oregon-trail-park-adjacent-apartments",
      "search_query": "Oregon Trail Park adjacent apartments",
      "category": "Park",
      "h1_title": "Oregon Trail Park Adjacent Apartments",
      "h2_subtitle": "Live in apartments adjacent to Oregon Trail Park. Discover the perfect blend of natural beauty and convenience at Millcreek Woods.",
      "page_copy": "Adjacent to the historic Oregon Trail Park, Millcreek Woods Apartment Homes provide an ideal location for those who appreciate both heritage and modern living amenities. Choose from our studio, one-, and two-bedroom options, set in a picturesque environment.\n\nAt Millcreek Woods, enjoy features like a scenic lake and a nearby nature trail, enhancing your living experience with natural beauty and outdoor recreation. With flexible rent payment options and reliable on-site maintenance, our apartments offer not only convenience but also peace of mind. Discover the perfect mix of heritage, nature, and modern comforts at our community near Oregon Trail Park in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oregon Trail Park Adjacent Apartments",
      "seo_description": "Discover apartments adjacent to Oregon Trail Park. Millcreek Woods offers a natural and convenient lifestyle in Olathe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "mahaffie-pond-park-proximal-apartments",
      "search_query": "Mahaffie Pond Park proximal Olathe apartments",
      "category": "Park",
      "h1_title": "Mahaffie Pond Park Proximal Olathe Apartments",
      "h2_subtitle": "Explore apartments proximal to Mahaffie Pond Park. Millcreek Woods offers scenic living in the heart of Olathe, KS.",
      "page_copy": "Enjoy the convenience of living near Mahaffie Pond Park at Millcreek Woods Apartment Homes, located in the vibrant city of Olathe, KS. Choose from well-appointed studio, one-, and two-bedroom apartments that provide comfortable living spaces close to local attractions.\n\nWith amenities like a scenic lake and a nature trail, Millcreek Woods enhances the enjoyment of surrounding natural beauty and promotes an active lifestyle. Residents benefit from flexible rent payment options and efficient on-site maintenance services. Embrace a seamless blend of outdoor experiences and urban amenities at our community proximal to Mahaffie Pond Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mahaffie Pond Park Proximal Olathe Apartments",
      "seo_description": "Find Olathe apartments near Mahaffie Pond Park. Enjoy a blend of natural beauty and urban living at Millcreek Woods Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167603",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Find comfort in apartments near Kansas City International Airport. Millcreek Woods Apartments offer convenient living in Olathe, KS.",
      "page_copy": "Millcreek Woods Apartment Homes provide an excellent living option for those seeking proximity to Kansas City International Airport. Located in Olathe, our community offers studio, one-, and two-bedroom apartments, ideal for frequent travelers and busy professionals.\n\nResidents enjoy diverse amenities including a scenic lake, nature trail, and a volleyball court, enhancing both convenience and lifestyle. Flexible rent payment options and on-site maintenance ensure a hassle-free living experience. Choose Millcreek Woods for a strategic location where the modern comforts of Olathe meet easy access to Kansas City International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
      "featured_image_media": {
        "alt_text": "Community clubhouse with deck and grill, parking lot, and tennis courts in background.",
        "public_id": "01a01012-ceda-74f9-8af3-950ab7cfe52d",
        "storage_key": "property/6767906449167603/01a01012-ceda-74f9-8af3-950ab7cfe52d.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Discover Olathe apartments close to Kansas City International Airport with modern amenities at Millcreek Woods.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701890665"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N2THRQC3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/13b7d5f2-dc68-4bc7-af3b-1e04bf98f25c/app.js?nocache=1&gaTracking=G-BKBTKNL9VH&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-430-9815"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imk1Z1YwMHVxcWFzcnZ5V1kveFNqSnc9PSIsInZhbHVlIjoieFZwSEFpc1NVRlhQMzBnNkl4OUhhdz09IiwibWFjIjoiODE5YTA4OTQ3Mzk0YWFkNTE4ZjUzZDRhOWY1MTdmZTIxZTU5Y2NkZmYwZTBiZTBlZDlkMzkxYmMxMGQxZWQ5NyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701890665",
  "custom_google_gtm_id": "GTM-N2THRQC3",
  "custom_rollout_phase": "Batch 8",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/13b7d5f2-dc68-4bc7-af3b-1e04bf98f25c/app.js?nocache=1&gaTracking=G-BKBTKNL9VH&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-430-9815",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imk1Z1YwMHVxcWFzcnZ5V1kveFNqSnc9PSIsInZhbHVlIjoieFZwSEFpc1NVRlhQMzBnNkl4OUhhdz09IiwibWFjIjoiODE5YTA4OTQ3Mzk0YWFkNTE4ZjUzZDRhOWY1MTdmZTIxZTU5Y2NkZmYwZTBiZTBlZDlkMzkxYmMxMGQxZWQ5NyJ9",
  "custom_audioeye_site_id": "6aa73e77-6272-4fbf-a739-0cb6d35bdf22",
  "custom_audioeye_site_hash": "f96507336816b09aa0d3f3a5d5b828f4"
};

export const generatedAt = '2026-11-03T22:58:04.852Z';
